require.register("local-data/poll_results/debt-management-what-you-learned.json", function(exports, require, module) {
  module.exports = (function() {
return {
    "data": {
        "id": "debt-management-what-you-learned_pollResult",
        "type": "poll_results",
        "attributes": {
            "results": {
                "sections": [
                    {
                        "id": "EX_POLL_RESULT_SECTION_ID_1",
                        "questions": [
                            {
                                "id": "EX_QUES_1",
                                "text": "Do you feel like you know more about debt and debt management strategies than before you started this course?",
                                "answers": [
                                    {
                                        "id": "EX_ANS_1",
                                        "text": "Yes",
                                        "count": 21312
                                    },
                                    {
                                        "id": "EX_ANS_2",
                                        "text": "No",
                                        "count": 9344
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    }
}
  })();
});

require.register("local-data/poll_results/scenarios-financial-action-plan.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "28aba4df-240c-4567-82fe-26aea9faf1a2",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [{
          "id": 66,
          "questions": [{
            "id": 266,
            "text": "Which of the following best describes you?",
            "answers": [{
                "id": 1057,
                "text": "I save some money per month",
                "count": 200
              },
              {
                "id": 1058,
                "text": "I know about savings accounts",
                "count": 100
              },
              {
                "id": 1059,
                "text": "I want to speak with a financial institution to learn more",
                "count": 320
              }
            ]
          }]
        }]
      }
    }
  }
}
  })();
});

require.register("local-data/poll_results/emily-financial-burden.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 68,
            "questions": [
              {
                "id": 276,
                "text": "Who got the best financial deal?",
                "answers": [
                  {
                    "id": 1064,
                    "text": "Javier", 
                    "count": 10
                  },
                  {
                    "id": 1065,
                    "text": "Min Ho",
                    "count": 20
                  }
                ]
              }
            ]
          },
          {
            "id": 69,
            "questions": [
              {
                "id": 276,
                "text": "What other debt management strategies can Emily use?",
                "answers": [
                  {
                    "id": 1064,
                    "text": "Discuss getting a reduced APR with creditors", 
                    "count": 10
                  },
                  {
                    "id": 1065,
                    "text": "Consolidate student loans",
                    "count": 20
                  },
                  {
                    "id": 1066,
                    "text": "Consolidate credit cards",
                    "count": 30
                  }
                ]
              }
            ]
          },
          {
            "id": 70,
            "questions": [
              {
                "id": 276,
                "text": "What change can Emily make to her budget to make the most impact?",
                "answers": [
                  {
                    "id": 1064,
                    "text": "Reduce her spending overall", 
                    "count": 10
                  },
                  {
                    "id": 1065,
                    "text": "Get a more affordable cell phone or cable plan",
                    "count": 20
                  },
                  {
                    "id": 1066,
                    "text": "Reduce gas by carpooling",
                    "count": 30
                  },
                  {
                    "id": 1067,
                    "text": "Spend less on clothing, shoes, and hair",
                    "count": 30
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/wesb-p7.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "What other options would work for Ali so that his money is protected?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "A checking account",
                    "count": 10
                  },
                  {
                    "id": 1084,
                    "text": "A traditional savings account.",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A certificate of deposit (CD)",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A money market account (MMA)",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A special account for a minor",
                    "count": 3
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-budget-plan.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "6d725c95-1c66-4faa-b51f-82b0247a5977",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 68,
            "questions": [
              {
                "id": 271,
                "text": "What is Marta’s monthly income?",
                "answers": [
                  {
                    "id": 1070,
                    "text": "$1000",
                    "count": 100
                  },
                  {
                    "id": 1071,
                    "text": "$3000",
                    "count": 10
                  },
                  {
                    "id": 1071,
                    "text": "$2000",
                    "count": 300
                  }
                ]
              },
              {
                "id": 272,
                "text": "What is the total amount of Marta’s needs?",
                "answers": [
                  {
                    "id": 1070,
                    "text": "$1000",
                    "count": 10
                  },
                  {
                    "id": 1071,
                    "text": "$1220",
                    "count": 100
                  },
                  {
                    "id": 1071,
                    "text": "$2200",
                    "count": 30
                  }
                ]
              },
              {
                "id": 273,
                "text": "If Marta’s monthly income is $2,000 and her needs total $1,220, what is Marta’s disposable income?",
                "answers": [
                  {
                    "id": 1070,
                    "text": "$1220",
                    "count": 10
                  },
                  {
                    "id": 1071,
                    "text": "$780",
                    "count": 100
                  },
                  {
                    "id": 1071,
                    "text": "$2000",
                    "count": 30
                  }
                ]
              },
              {
                "id": 274,
                "text": "What is the total amount of Marta’s wants?",
                "answers": [
                  {
                    "id": 1070,
                    "text": "$110",
                    "count": 10
                  },
                  {
                    "id": 1071,
                    "text": "$210",
                    "count": 100
                  },
                  {
                    "id": 1071,
                    "text": "$310",
                    "count": 30
                  }
                ]
              },
              {
                "id": 275,
                "text": "Marta wants to contribute $100 of her $570 of disposable income to her savings account. How much is she left with?",
                "answers": [
                  {
                    "id": 1070,
                    "text": "$270",
                    "count": 10
                  },
                  {
                    "id": 1071,
                    "text": "$370",
                    "count": 100
                  },
                  {
                    "id": 1071,
                    "text": "$470",
                    "count": 30
                  }
                ]
              },
              {
                "id": 276,
                "text": "How much does Marta pay to her debts each month?",
                "answers": [
                  {
                    "id": 1070,
                    "text": "$270",
                    "count": 10
                  },
                  {
                    "id": 1071,
                    "text": "$370",
                    "count": 100
                  },
                  {
                    "id": 1071,
                    "text": "$470",
                    "count": 30
                  }
                ]
              },
              {
                "id": 277,
                "text": "How much does Marta pay to her debts each month?",
                "answers": [
                  {
                    "id": 1070,
                    "text": "$7000",
                    "count": 10
                  },
                  {
                    "id": 1071,
                    "text": "$200",
                    "count": 100
                  },
                  {
                    "id": 1071,
                    "text": "$300",
                    "count": 30
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-credit-scams.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "The first agency promised to remove bad credit information",
                "answers": [
                  {
                    "id": 1083,
                    "text": "YES",
                    "count": 1
                  },
                  {
                    "id": 1084,
                    "text": "NO",
                    "count": 5
                  }
                ]
              },
              {
                "id": 277,
                "text": "The agency required Anna to pay a fee up front",
                "answers": [
                  {
                    "id": 1089,
                    "text": "YES",
                    "count": 2
                  },
                  {
                    "id": 1090,
                    "text": "NO",
                    "count": 4
                  }
                ]
              },
              {
                "id": 278,
                "text": "The company claimed they could scrub all negative information",
                "answers": [
                  {
                    "id": 1086,
                    "text": "YES",
                    "count": 7
                  },
                  {
                    "id": 1087,
                    "text": "NO",
                    "count": 2
                  }
                ]
              },
              {
                "id": 279,
                "text": "They advised her not to contact the credit bureaus",
                "answers": [
                  {
                    "id": 1086,
                    "text": "YES",
                    "count": 1
                  },
                  {
                    "id": 1087,
                    "text": "NO",
                    "count": 5
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/poll-result-example.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "EX_POLL_RESULT_ID",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": "EX_POLL_RESULT_SECTION_ID_1",
            "questions": [
              {
                "id": "EX_QUES_1",
                "text": "I keep a record of what I earn each month.",
                "answers": [
                  {
                    "id": "EX_ANS_1",
                    "text": "Yes",
                    "count": 21312
                  },
                  {
                    "id": "EX_ANS_2",
                    "text": "Yes",
                    "count": 9344
                  },
                  {
                    "id": "EX_ANS_3",
                    "text": "Yes",
                    "count": 689
                  },
                  {
                    "id": "EX_ANS_4",
                    "text": "Yes",
                    "count": 5656
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
  })();
});

require.register("local-data/poll_results/scenarios-stay-on-track.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "Which of the following statements have you said to yourself?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "I'll wake up early to exercise tomorrow",
                    "count": 10
                  },
                  {
                    "id": 1084,
                    "text": "I'll start saving when I get a raise",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "I'll go to bed early tomorrow",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "I'll stop watching after this one last episode",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "I'll borrow less on my credit card next month",
                    "count": 3
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-identity-theft.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "Have you ever lost a cell phone?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "YES",
                    "count": 1
                  },
                  {
                    "id": 1084,
                    "text": "NO",
                    "count": 3
                  }
                ]
              },
              {
                "id": 277,
                "text": "Have you ever thrown away or recycled bank statements?",
                "answers": [
                  {
                    "id": 1089,
                    "text": "YES",
                    "count": 1
                  },
                  {
                    "id": 1090,
                    "text": "NO",
                    "count": 5
                  }
                ]
              },
              {
                "id": 278,
                "text": "Have you ever thrown away or recycled medical bills?",
                "answers": [
                  {
                    "id": 1086,
                    "text": "YES",
                    "count": 5
                  },
                  {
                    "id": 1087,
                    "text": "NO",
                    "count": 1
                  }
                ]
              },
              {
                "id": 279,
                "text": "Have you ever thrown away or recycled tax statements?",
                "answers": [
                  {
                    "id": 1086,
                    "text": "YES",
                    "count": 7
                  },
                  {
                    "id": 1087,
                    "text": "NO",
                    "count": 4
                  }
                ]
              },
              {
                "id": 280,
                "text": "Have you ever thrown away or recycled credit card bills?",
                "answers": [
                  {
                    "id": 1086,
                    "text": "YES",
                    "count": 5
                  },
                  {
                    "id": 1087,
                    "text": "NO",
                    "count": 5
                  }
                ]
              },
              {
                "id": 281,
                "text": "Have you ever thrown away or recycled insurance bills?",
                "answers": [
                  {
                    "id": 1086,
                    "text": "YES",
                    "count": 4
                  },
                  {
                    "id": 1087,
                    "text": "NO",
                    "count": 1
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-joe-shop-positive-equity-position.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "6d725c95-1c66-4faa-b51f-82b0247a5977",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 68,
            "questions": [
              {
                "id": 271,
                "text": "What is Joe's T-Shirt Shop working capital position?",
                "answers": [
                  {
                    "id": 1070,
                    "text": "Negative Working Capital",
                    "count": 1000
                  },
                  {
                    "id": 1071,
                    "text": "Positive/Acceptable Working Capital",
                    "count": 300
                  },
                  {
                    "id": 1071,
                    "text": "Strong Working Capital",
                    "count": 300
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-cost-merging.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "Will co-signing affect Bella’s credit score?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "YES",
                    "count": 1
                  },
                  {
                    "id": 1084,
                    "text": "NO",
                    "count": 5
                  }
                ]
              },
              {
                "id": 277,
                "text": "Will it affect her score positively or negatively?",
                "answers": [
                  {
                    "id": 1089,
                    "text": "POSITIVELY",
                    "count": 2
                  },
                  {
                    "id": 1090,
                    "text": "NEGATIVELY",
                    "count": 4
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
  })();
});

require.register("local-data/poll_results/wesb-p5.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "What other options would work for Ali so that his money is protected?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "A checking account",
                    "count": 10
                  },
                  {
                    "id": 1084,
                    "text": "A traditional savings account.",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A certificate of deposit (CD)",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A money market account (MMA)",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A special account for a minor",
                    "count": 3
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/slg10.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "sections": [
    {
      "id": "1",
      "questions": [
        {
          "id": "2",
          "answers": [
            {
              "id": "3",
              "count": "8",
              "text": "ans1"
            },
            {
              "id": "33",
              "count": "1",
              "text": "ans2"
            }
          ]
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/poll_results/martas-goals.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "6d725c95-1c66-4faa-b51f-82b0247a5977",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 68,
            "questions": [
              {
                "id": 271,
                "text": "Checking accounts",
                "answers": [
                  {
                    "id": 1070,
                    "text": "Short",
                    "count": 1000
                  },
                  {
                    "id": 1071,
                    "text": "Medium",
                    "count": 300
                  },
                  {
                    "id": 1072,
                    "text": "Long",
                    "count": 300
                  }
                ]
              },
              {
                "id": 272,
                "text": "Buy a new phone",
                "answers": [
                  {
                    "id": 1070,
                    "text": "Short",
                    "count": 1000
                  },
                  {
                    "id": 1071,
                    "text": "Medium",
                    "count": 300
                  },
                  {
                    "id": 1072,
                    "text": "Long",
                    "count": 300
                  }
                ]
              },
              {
                "id": 273,
                "text": "Pay off credit cards",
                "answers": [
                  {
                    "id": 1070,
                    "text": "Short",
                    "count": 1000
                  },
                  {
                    "id": 1071,
                    "text": "Medium",
                    "count": 300
                  },
                  {
                    "id": 1072,
                    "text": "Long",
                    "count": 300
                  }
                ]
              },
              {
                "id": 274,
                "text": "Pay off credit cards",
                "answers": [
                  {
                    "id": 1070,
                    "text": "Short",
                    "count": 1000
                  },
                  {
                    "id": 1071,
                    "text": "Medium",
                    "count": 300
                  },
                  {
                    "id": 1072,
                    "text": "Long",
                    "count": 300
                  }
                ]
              },
              {
                "id": 275,
                "text": "Save for a down payment on a house",
                "answers": [
                  {
                    "id": 1070,
                    "text": "Short",
                    "count": 1000
                  },
                  {
                    "id": 1071,
                    "text": "Medium",
                    "count": 300
                  },
                  {
                    "id": 1072,
                    "text": "Long",
                    "count": 300
                  }
                ]
              },
              {
                "id": 276,
                "text": "Pay off student loans",
                "answers": [
                  {
                    "id": 1070,
                    "text": "Short",
                    "count": 1000
                  },
                  {
                    "id": 1071,
                    "text": "Medium",
                    "count": 300
                  },
                  {
                    "id": 1072,
                    "text": "Long",
                    "count": 300
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-joe-shop-cash-flow.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4924",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 79,
            "questions": [
              {
                "id": 300,
                "text": "Does Joe’s T-Shirt Print Shop have a positive cash balance?",
                "answers": [
                  {
                    "id": 1200,
                    "text": "Yes",
                    "count": 1
                  },
                  {
                    "id": 1201,
                    "text": "No",
                    "count": 5
                  }
                ]
              },
              {
                "id": 301,
                "text": "Should Joe take out a loan to cover short-term cash needs?",
                "answers": [
                  {
                    "id": 1200,
                    "text": "Yes",
                    "count": 4
                  },
                  {
                    "id": 1201,
                    "text": "No",
                    "count": 1
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-term-loan.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "What credit type do you need?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "Unsecured ",
                    "count": 7
                  },
                  {
                    "id": 1084,
                    "text": "Real estate Secured",
                    "count": 8
                  },
                  {
                    "id": 1085,
                    "text": "Non-real estate Secured",
                    "count": 5
                  }
                ]
              },
              {
                "id": 278,
                "text": "What credit type do you need?",
                "answers": [
                  {
                    "id": 1089,
                    "text": "Unsecured",
                    "count": 2
                  },
                  {
                    "id": 1090,
                    "text": "Real Estate Secured",
                    "count": 5
                  },
                  {
                    "id": 1091,
                    "text": "Non-real Estate Secured",
                    "count": 7
                  }
                ]
              },
              {
                "id": 277,
                "text": "What credit type do you need?",
                "answers": [
                  {
                    "id": 1086,
                    "text": "Unsecured ",
                    "count": 2
                  },
                  {
                    "id": 1087,
                    "text": "Real estate Secured",
                    "count": 6
                  },
                  {
                    "id": 1088,
                    "text": "Non-real estate Secured",
                    "count": 8
                  },
                  {
                    "id": 1092,
                    "text": "Line of Credit",
                    "count": 10
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/rooftop-repair-quiz.json", function(exports, require, module) {
  module.exports = (function() {
return {
    "data": {
      "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
      "type": "poll_results",
      "attributes": {
        "results": {
          "sections": [
            {
              "id": 68,
              "questions": [
                {
                  "id": 271,
                  "text": "If Ralph makes a monthly payment of $50 per month on his credit card, how long will it take him to pay off the roof repair?",
                  "answers": [
                    {
                      "id": 1070,
                      "text": "135 months",
                      "count": 5
                    },
                    {
                      "id": 1071,
                      "text": "35 months",
                      "count": 70
                    },
                    {
                      "id": 1072,
                      "text": "11 months",
                      "count": 25
                    }
                  ]
                },
                {
                  "id": 272,
                  "text": "What will the total cost of the repair cost Ralph if he only pays $50 per month?",
                  "answers": [
                    {
                      "id": 1073,
                      "text": "$3,000",
                      "count": 30
                    },
                    {
                      "id": 1074,
                      "text": "$3,743",
                      "count": 20
                    },
                    {
                      "id": 1075,
                      "text": "$6,743",
                      "count": 90
                    }

                  ]
                }
              ]
            }
          ]
        }
      }
    }
  }
  
  })();
});

require.register("local-data/poll_results/leading-sources-of-debt.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "leading-sources-of-debt_pollResult",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": "EX_POLL_RESULT_SECTION_ID_1",
            "questions": [
              {
                "id": "EX_QUES_1",
                "text": "What is the leading source of debt in America?",
                "answers": [
                  {
                    "id": "EX_ANS_1",
                    "text": "Mortgage debt",
                    "count": 21312
                  },
                  {
                    "id": "EX_ANS_2",
                    "text": "Student loan debt",
                    "count": 9344
                  },
                  {
                    "id": "EX_ANS_3",
                    "text": "Credit card debt",
                    "count": 689
                  },
                  {
                    "id": "EX_ANS_4",
                    "text": "Car loan debt",
                    "count": 5656
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-goal-setting.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4924",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 79,
            "questions": [
              {
                "id": 300,
                "text": "Take a vacation",
                "answers": [
                  {
                    "id": 1200,
                    "text": "Short-term",
                    "count": 2
                  },
                  {
                    "id": 1201,
                    "text": "Medium-term",
                    "count": 5
                  },

                  {
                    "id": 1202,
                    "text": "Long-term",
                    "count": 7
                  }
                ]
              },
              {
                "id": 301,
                "text": "Buy a new phone",
                "answers": [
                  {
                    "id": 1200,
                    "text": "Short-term",
                    "count": 1
                  },
                  {
                    "id": 1201,
                    "text": "Medium-term",
                    "count": 5
                  },

                  {
                    "id": 1202,
                    "text": "Long-term",
                    "count": 4
                  }
                ]
              },
               {
                "id": 302,
                "text": "Pay off credit cards",
                "answers": [
                  {
                    "id": 1200,
                    "text": "Short-term",
                    "count": 1
                  },
                  {
                    "id": 1201,
                    "text": "Medium-term",
                    "count": 4
                  },

                  {
                    "id": 1202,
                    "text": "Long-term",
                    "count": 5
                  }
                ]
              },
              {
                "id": 303,
                "text": "Save for a down payment on a house",
                "answers": [
                  {
                    "id": 1200,
                    "text": "Short-term",
                    "count": 7
                  },
                  {
                    "id": 1201,
                    "text": "Medium-term",
                    "count": 5
                  },

                  {
                    "id": 1202,
                    "text": "Long-term",
                    "count": 6
                  }
                ]
              },
              {
                "id": 304,
                "text": "Pay off student loans",
                "answers": [
                  {
                    "id": 1200,
                    "text": "Short-term",
                    "count": 1
                  },
                  {
                    "id": 1201,
                    "text": "Medium-term",
                    "count": 5
                  },

                  {
                    "id": 1202,
                    "text": "Long-term",
                    "count": 6
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-using-business-cards.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "6d725c95-1c66-4faa-b51f-82b0247a5977",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 68,
            "questions": [
              {
                "id": 271,
                "text": "Which one should you use",
                "answers": [
                  {
                    "id": 1070,
                    "text": "Debit",
                    "count": 2
                  },
                  {
                    "id": 1071,
                    "text": "Credit",
                    "count": 5
                  }
                ]
              }
            ]
          },
          {
            "id": 68,
            "questions": [
              {
                "id": 272,
                "text": "Which one should you use",
                "answers": [
                  {
                    "id": 1070,
                    "text": "Debit",
                    "count": 2
                  },
                  {
                    "id": 1071,
                    "text": "Credit",
                    "count": 5
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-business-cards.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "13696615-9bc6-4fb3-b507-ed81c634a3b6",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 67,
            "questions": [
              {
                "id": 267,
                "text": "You are at an office supply store over the weekend and need to stock up on basics like paper, printer toner, and pens.\nWhat credit type do you need?",
                "answers": [
                  {
                    "id": 1058,
                    "text": "Lines of Credit",
                    "count": 500
                  },
                  {
                    "id": 1059,
                    "text": "Personal Credit Card",
                    "count": 300
                  },
                  {
                    "id": 1060,
                    "text": "Business Credit Card",
                    "count": 320
                  }
                ]
              },
              {
                "id": 268,
                "text": "You own a grocery store, and one of your vendors is offering a great deal on a line of shampoos that are suddenly very popular. The only caveat? You need to order it immediately!\nHow would you make the purchase?",
                "answers": [
                  {
                    "id": 1061,
                    "text": "Lines of Credit",
                    "count": 230
                  },
                  {
                    "id": 1062,
                    "text": "Term Loans",
                    "count": 240
                  },
                  {
                    "id": 1063,
                    "text": "Business Credit Card",
                    "count": 400
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-cost-joint.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "Will having a joint credit card or checking account affect Tameka’s credit score?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "YES",
                    "count": 1
                  },
                  {
                    "id": 1084,
                    "text": "NO",
                    "count": 5
                  }
                ]
              },
              {
                "id": 277,
                "text": "Will it affect her score positively or negatively?",
                "answers": [
                  {
                    "id": 1089,
                    "text": "POSITIVELY",
                    "count": 2
                  },
                  {
                    "id": 1090,
                    "text": "NEGATIVELY",
                    "count": 4
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
  })();
});

require.register("local-data/poll_results/wesb-p3.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "What other options would work for Ali so that his money is protected?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "A checking account",
                    "count": 10
                  },
                  {
                    "id": 1084,
                    "text": "A traditional savings account.",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A certificate of deposit (CD)",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A money market account (MMA)",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A special account for a minor",
                    "count": 3
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-joel-account.json", function(exports, require, module) {
  module.exports = (function() {
return {
    "data": {
      "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
      "type": "poll_results",
      "attributes": {
        "results": {
          "sections": [
            {
              "id": 68,
              "questions": [
                {
                  "id": 271,
                  "text": "Why was Joel’s account overdrawn?",
                  "answers": [
                    {
                      "id": 1070,
                      "text": "There was a mistake with his bank.",
                      "count": 5
                    },
                    {
                      "id": 1071,
                      "text": "Joel did not wait long enough for the funds to be available after depositing his check.",
                      "count": 70
                    },
                    {
                      "id": 1072,
                      "text": "You cannot use mobile banking to deposit checks",
                      "count": 25
                    }
                  ]
                },
                {
                  "id": 272,
                  "text": "Money deposited through mobile banking is always available immediately.",
                  "answers": [
                    {
                      "id": 1070,
                      "text": "True",
                      "count": 30
                    },
                    {
                      "id": 1071,
                      "text": "False",
                      "count": 70
                    }
                  ]
                },
                {
                  "id": 273,
                  "text": "Your financial institution may have a limit on how large a check you can deposit through mobile banking.",
                  "answers": [
                    {
                      "id": 1070,
                      "text": "True",
                      "count": 25
                    },
                    {
                      "id": 1071,
                      "text": "False",
                      "count": 75
                    }
                  ]
                },
                {
                  "id": 274,
                  "text": "Your financial institution may deposit some of the money from a mobile banking deposit immediately, but the rest may not be available until later.",
                  "answers": [
                    {
                      "id": 1070,
                      "text": "True",
                      "count": 20
                    },
                    {
                      "id": 1071,
                      "text": "False",
                      "count": 80
                    }
                  
                  ]
                }
              ]
            }
          ]
        }
      }
    }
  }
  
  })();
});

require.register("local-data/poll_results/protecting-money.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "What other options would work for Ali so that his money is protected?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "A checking account",
                    "count": 10
                  },
                  {
                    "id": 1084,
                    "text": "A traditional savings account.",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A certificate of deposit (CD)",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A money market account (MMA)",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A special account for a minor",
                    "count": 3
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/slg03.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "sections": [
    {
      "id": "1",
      "questions": [
        {
          "id": "2",
          "answers": [
            {
              "id": "3",
              "count": "8",
              "text": "ans1"
            },
            {
              "id": "33",
              "count": "1",
              "text": "ans2"
            },
            {
              "id": "333",
              "count": "5",
              "text": "ans3"
            }
          ]
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/poll_results/slg06.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "sections": [
    {
      "id": "1",
      "questions": [
        {
          "id": "2",
          "answers": [
            {
              "id": "3",
              "count": "8",
              "text": "ans1"
            },
            {
              "id": "33",
              "count": "1",
              "text": "ans2"
            },
            {
              "id": "333",
              "count": "5",
              "text": "ans3"
            }
          ]
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/poll_results/scenarios-real-estate-loans.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "9f967c25-9261-443a-a4dd-ca1de568a8e0",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 69,
            "questions": [
              {
                "id": 272,
                "text": "As the owner of a small freight trucking business, you’ve rented your office space for five years and are ready to purchase your own small office facility.\nWhat credit type do you need?",
                "answers": [
                  {
                    "id": 1073,
                    "text": "Owner occupied",
                    "count": 300
                  },
                  {
                    "id": 1074,
                    "text": "Non-owner occupied",
                    "count": 500
                  }
                ]
              },
              {
                "id": 273,
                "text": "Your company has recently acquired a competitor. To fully merge the two companies and create the type of company culture you want, you will need to have everyone headquartered in the same office space. You are tired of renting and want to purchase a building big enough for all your employees.\nWhat credit type do you need?",
                "answers": [
                  {
                    "id": 1075,
                    "text": "Owner occupied",
                    "count": 500
                  },
                  {
                    "id": 1076,
                    "text": "Non-owner occupied",
                    "count": 600
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/business-banking-needs.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "What other options would work for Ali so that his money is protected?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "Accepting payment from customers",
                    "count": 10
                  },
                  {
                    "id": 1084,
                    "text": "Making payments to vendors",
                    "count": 20
                  },
                  {
                    "id": 1084,
                    "text": "Making deposits",
                    "count": 40
                  },
                  {
                    "id": 1084,
                    "text": "Getting cash and change",
                    "count": 40
                  },
                  {
                    "id": 1084,
                    "text": "Paying employees and service providers",
                    "count": 20
                  },
                  {
                    "id": 1084,
                    "text": "Securing loans",
                    "count": 10
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-id-theft-results.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "Which of the following do you carry with you everyday?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "Credit Card",
                    "count": 100
                  },
                  {
                    "id": 1084,
                    "text": "Debit Card",
                    "count": 45
                  },
                  {
                    "id": 1085,
                    "text": "Driver’s License",
                    "count": 25
                  },
                  {
                    "id": 1086,
                    "text": "State ID",
                    "count": 50
                  },
                   {
                    "id": 1087,
                    "text": "Social Security Car",
                    "count": 77
                  },
                  {
                    "id": 1088,
                    "text": "Permanent Resident/Green Card",
                    "count": 99
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/cr-and-reports-surveys.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "6d725c95-1c66-4faa-b51f-82b0247a5977",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 74,
            "questions": [
              {
                "id": 269,
                "text": "I know what my credit score is.",
                "answers": [
                  {
                    "id": 1034,
                    "text": "YES",
                    "count": 1
                  },
                  {
                    "id": 1035,
                    "text": "NO",
                    "count": 2
                  }
                ]
              },
              {
                "id": 270,
                "text": "I always pay every bill on time every month.",
                "answers": [
                  {
                    "id": 1034,
                    "text": "YES",
                    "count": 2
                  },
                  {
                    "id": 1035,
                    "text": "NO",
                    "count": 5
                  }
                ]
              },
              {
                "id": 271,
                "text": "My credit is not ‘maxed out;’ the amount I owe is less than 30% of my available credit.",
                "answers": [
                  {
                    "id": 1034,
                    "text": "YES",
                    "count": 1
                  },
                  {
                    "id": 1035,
                    "text": "NO",
                    "count": 2
                  }
                ]
              },
              {
                "id": 272,
                "text": "I request a new credit report each year.",
                "answers": [
                  {
                    "id": 1034,
                    "text": "YES",
                    "count": 2
                  },
                  {
                    "id": 1035,
                    "text": "NO",
                    "count": 5
                  }
                ]
              },
              {
                "id": 273,
                "text": "I review my credit report each year to check and fix any errors.",
                "answers": [
                  {
                    "id": 1034,
                    "text": "YES",
                    "count": 2
                  },
                  {
                    "id": 1035,
                    "text": "NO",
                    "count": 5
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/joes-shop-profit-and-loss-results.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "6d725c95-1c66-4faa-b51f-82b0247a5977",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 74,
            "questions": [
              {
                "id": 269,
                "text": "1. Has Joe’s T-Shirt Print Shop earned more revenue than what they spent on production costs?",
                "answers": [
                  {
                    "id": 1034,
                    "text": "YES",
                    "count": 1
                  },
                  {
                    "id": 1035,
                    "text": "NO",
                    "count": 2
                  }
                ]
              },
              {
                "id": 270,
                "text": "2. Is Joe’s T-Shirt Print Shop profitable?",
                "answers": [
                  {
                    "id": 1034,
                    "text": "YES",
                    "count": 2
                  },
                  {
                    "id": 1035,
                    "text": "NO",
                    "count": 5
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-strategies.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "Which of her debts should Marta pay off first?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "Credit Card A",
                    "count": 1
                  },
                  {
                    "id": 1084,
                    "text": "Credit Card B",
                    "count": 5
                  },
                  {
                    "id": 1085,
                    "text": "Student Loans",
                    "count": 3
                  }
                ]
              },
              {
                "id": 278,
                "text": "Which of her debts should Martha pay off first?",
                "answers": [
                  {
                    "id": 1089,
                    "text": "Credit Card A",
                    "count": 4
                  },
                  {
                    "id": 1090,
                    "text": "Credit Card B",
                    "count": 3
                  },
                  {
                    "id": 1091,
                    "text": "Student Loans",
                    "count": 5
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/financial-emergency.json", function(exports, require, module) {
  module.exports = (function() {
return {
    "data": {
      "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
      "type": "poll_results",
      "attributes": {
        "results": {
          "sections": [
            {
              "id": 68,
              "questions": [
                {
                  "id": 269,
                  "text": "You blow a tire and need to buy a new one.",
                  "answers": [
                    {
                      "id": 1064,
                      "text": "Yes",
                      "count": 85
                    },
                    {
                      "id": 1065,
                      "text": "No",
                      "count": 19
                    }
                  ]
                },
                {
                  "id": 270,
                  "text": "You slipped on your deck and need to go to the ER.",
                  "answers": [
                    {
                      "id": 1064,
                      "text": "Yes",
                      "count": 90
                    },
                    {
                      "id": 1065,
                      "text": "No",
                      "count": 8
                    }
                  ]
                },
                {
                  "id": 271,
                  "text": "Your video game console breaks suddenly.",
                  "answers": [
                    {
                      "id": 1064,
                      "text": "Yes",
                      "count": 8
                    },
                    {
                      "id": 1065,
                      "text": "No",
                      "count": 81
                    }
                  ]
                },
                {
                  "id": 272,
                  "text": "Your furnace breaks in January.",
                  "answers": [
                    {
                      "id": 1064,
                      "text": "Yes",
                      "count": 85
                    },
                    {
                      "id": 1065,
                      "text": "No",
                      "count": 78
                    }
                  ]
                },
                {
                  "id": 273,
                  "text": "Your laptop breaks. You are a freelancer and need your laptop for work.",
                  "answers": [
                    {
                      "id": 1064,
                      "text": "Yes",
                      "count": 91
                    },
                    {
                      "id": 1065,
                      "text": "No",
                      "count": 19
                    }
                  ]
                },
                {
                  "id": 274,
                  "text": "Your laptop breaks. You do not need your laptop for your job, but you enjoy watching movies on it.",
                  "answers": [
                    {
                      "id": 1064,
                      "text": "Yes",
                      "count": 80
                    },
                    {
                      "id": 1065,
                      "text": "No",
                      "count": 98
                    }

                  ]
                }
              ]
            }
          ]
        }
      }
    }
  }

  })();
});

require.register("local-data/poll_results/scenarios-sew-rights.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "6d725c95-1c66-4faa-b51f-82b0247a5977",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 68,
            "questions": [
              {
                "id": 271,
                "text": "Which of the following “Cs” will her credit card history affect when a Lender is considering whether to give her a loan?",
                "answers": [
                  {
                    "id": 1070,
                    "text": "Character",
                    "count": 1000
                  },
                  {
                    "id": 1071,
                    "text": "Capacity",
                    "count": 300
                  },
                  {
                    "id": 1070,
                    "text": "Capital",
                    "count": 30
                  },
                  {
                    "id": 1071,
                    "text": "Collateral",
                    "count": 30
                  },
                  {
                    "id": 1072,
                    "text": "Conditions",
                    "count": 30
                  }
                ]
              },
              {
                "id": 272,
                "text": "Which of the following ‘Cs’will her asset ownership affect when a Lender is considering whether to give her a loan?",
                "answers": [
                  {
                    "id": 1073,
                    "text": "Character",
                    "count": 1000
                  },
                  {
                    "id": 1074,
                    "text": "Capacity",
                    "count": 300
                  },
                  {
                    "id": 1070,
                    "text": "Capacity",
                    "count": 1000
                  },
                  {
                    "id": 1071,
                    "text": "Collateral",
                    "count": 1000
                  },
                  {
                    "id": 1075,
                    "text": "Conditions",
                    "count": 1000
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/wesb-p6.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "What other options would work for Ali so that his money is protected?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "A checking account",
                    "count": 10
                  },
                  {
                    "id": 1084,
                    "text": "A traditional savings account.",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A certificate of deposit (CD)",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A money market account (MMA)",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A special account for a minor",
                    "count": 3
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-marta-budget.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "",
                "answers": [
                  {
                    "id": 1083,
                    "text": "YES",
                    "count": 1
                  },
                  {
                    "id": 1084,
                    "text": "NO",
                    "count": 5
                  }
                ]
              },
              {
                "id": 277,
                "text": "",
                "answers": [
                  {
                    "id": 1089,
                    "text": "YES",
                    "count": 2
                  },
                  {
                    "id": 1090,
                    "text": "NO",
                    "count": 4
                  }
                ]
              },
              {
                "id": 278,
                "text": "",
                "answers": [
                  {
                    "id": 1086,
                    "text": "YES",
                    "count": 7
                  },
                  {
                    "id": 1087,
                    "text": "NO",
                    "count": 2
                  }
                ]
              },
              {
                "id": 279,
                "text": "",
                "answers": [
                  {
                    "id": 1086,
                    "text": "YES",
                    "count": 1
                  },
                  {
                    "id": 1087,
                    "text": "NO",
                    "count": 5
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-tale-of-two-friends.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "Who had more trouble getting a loan?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "ANNA",
                    "count": 1
                  },
                  {
                    "id": 1084,
                    "text": "BELLA",
                    "count": 5
                  }
                ]
              },
              {
                "id": 277,
                "text": "Who had more trouble getting a loan?",
                "answers": [
                  {
                    "id": 1089,
                    "text": "ANNA",
                    "count":6
                  },
                  {
                    "id": 1090,
                    "text": "BELLA",
                    "count": 2
                  }
                ]
              },
              {
                "id": 278,
                "text": "Who had a higher interest rate?",
                "answers": [
                  {
                    "id": 1086,
                    "text": "ANNA",
                    "count": 2
                  },
                  {
                    "id": 1087,
                    "text": "BELLA",
                    "count": 5
                  }
                ]
              },
              {
                "id": 279,
                "text": "Whose insurance rates were higher?",
                "answers": [
                  {
                    "id": 1086,
                    "text": "ANNA",
                    "count": 2
                  },
                  {
                    "id": 1087,
                    "text": "BELLA",
                    "count": 5
                  }
                ]
              },
              {
                "id": 280,
                "text": "Whose home fell into foreclosure?",
                "answers": [
                  {
                    "id": 1086,
                    "text": "ANNA",
                    "count": 2
                  },
                  {
                    "id": 1087,
                    "text": "BELLA",
                    "count": 5
                  }
                ]
              },
              {
                "id": 281,
                "text": "Whose home fell into foreclosure?",
                "answers": [
                  {
                    "id": 1086,
                    "text": "ANNA",
                    "count": 2
                  },
                  {
                    "id": 1087,
                    "text": "BELLA",
                    "count": 5
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}


  })();
});

require.register("local-data/poll_results/slg11.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "sections": [
    {
      "id": "1",
      "questions": [
        {
          "id": "1",
          "text": "Could ideas on a napkin be a business plan? ",
          "answers": [
            {
              "id": "3",
              "count": "8",
              "textAns": "TRUE",
              "flag": "op1"
            },
            {
              "id": "33",
              "count": "1",
              "textAns": "FALSE",
              "flag": "op2"
            }
          ]
        },
        {
          "id": "2",
          "text": "Could a one-pager be a business plan?",
          "answers": [
            {
              "id": "4",
              "count": "6",
              "text": "TRUE",
              "flag": "op1"
            },
            {
              "id": "33",
              "count": "4",
              "text": "FALSE",
              "flag": "op2"
            }
          ]
        },
        {
          "id": "3",
          "text": "Could a 30-page document be a business plan? ",
          "answers": [
            {
              "id": "3",
              "count": "5",
              "text": "TRUE",
              "flag": "op1"
            },
            {
              "id": "33",
              "count": "5",
              "text": "FALSE",
              "flag": "op2"
            }
          ]
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/poll_results/how-much-did-you-learn.json", function(exports, require, module) {
  module.exports = (function() {
return {
    "data": {
      "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
      "type": "poll_results",
      "attributes": {
        "results": {
          "sections": [
            {
              "id": 68,
              "questions": [
                {
                  "id": 271,
                  "text": "Do you feel you learned more about mobile banking after taking this course?",
                  "answers": [
                    {
                      "id": 1070,
                      "text": "True",
                      "count": 90
                    },
                    {
                      "id": 1071,
                      "text": "False",
                      "count": 10
                    }
                  ]
                }
              ]
            }
          ]
        }
      }
    }
  }
  
  })();
});

require.register("local-data/poll_results/slg02.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "sections": [
    {
      "id": "1",
      "questions": [
        {
          "id": "2",
          "answers": [
            {
              "id": "3",
              "count": "8",
              "text": "ans1"
            },
            {
              "id": "33",
              "count": "1",
              "text": "ans2"
            },
            {
              "id": "333",
              "count": "5",
              "text": "ans3"
            }
          ]
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/poll_results/scenarios-build-budget.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001113",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "Is Marta spending too much on needs?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "YES",
                    "count": 1
                  },
                  {
                    "id": 1084,
                    "text": "NO",
                    "count": 5
                  }
                ]
              },
              {
                "id": 277,
                "text": "Is Marta spending too much on wants?",
                "answers": [
                  {
                    "id": 1089,
                    "text": "YES",
                    "count": 2
                  },
                  {
                    "id": 1090,
                    "text": "NO",
                    "count": 4
                  }
                ]
              },
              {
                "id": 278,
                "text": "Does Marta have enough to save or repay her debts??",
                "answers": [
                  {
                    "id": 1091,
                    "text": "YES",
                    "count": 2
                  },
                  {
                    "id": 1092,
                    "text": "NO",
                    "count": 4
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
  })();
});

require.register("local-data/poll_results/types-of-accounts.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "Checking accounts?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "Very",
                    "count": 10
                  },
                  {
                    "id": 1084,
                    "text": "Somewhat",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "Not at all",
                    "count": 3
                  }
                ]
              },
              {
                "id": 277,
                "text": "Money market accounts?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "Very",
                    "count": 10
                  },
                  {
                    "id": 1084,
                    "text": "Somewhat",
                    "count": 50
                  },
                  {
                    "id": 1084,
                    "text": "Not at all",
                    "count": 10
                  }
                ]
              },
              {
                "id": 278,
                "text": "Certificates of deposit?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "Very",
                    "count": 15
                  },
                  {
                    "id": 1084,
                    "text": "Somewhat",
                    "count": 35
                  },
                  {
                    "id": 1084,
                    "text": "Not at all",
                    "count": 30
                  }
                ]
              },
              {
                "id": 279,
                "text": "Money market accounts?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "Very",
                    "count": 19
                  },
                  {
                    "id": 1084,
                    "text": "Somewhat",
                    "count": 31
                  },
                  {
                    "id": 1084,
                    "text": "Not at all",
                    "count": 35
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-list-expenses-needs.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "How much disposable income does Marta have left after paying for her needs?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "$420",
                    "count": 1
                  },
                  {
                    "id": 1084,
                    "text": "$480",
                    "count": 5
                  }
                ]
              },
              {
                "id": 277,
                "text": "How much disposable income does Marta have left after paying for both her needs and wants?",
                "answers": [
                  {
                    "id": 1085,
                    "text": "$210",
                    "count": 5
                  },
                  {
                    "id": 1086,
                    "text": "$270",
                    "count": 8
                  }
                ]
              },
              {
                "id": 278,
                "text": "How much disposable income does Marta have left after paying for her expenses and adding to her savings?",
                "answers": [
                  {
                    "id": 1087,
                    "text": "$210",
                    "count": 5
                  },
                  {
                    "id": 1088,
                    "text": "$170",
                    "count": 2
                  }
                ]
              },
              {
                "id": 279,
                "text": "What are some possible uses for Marta’s $170 in disposable income?",
                "answers": [
                  {
                    "id": 1089,
                    "text": "Pay off student loans",
                    "count": 12
                  },
                  {
                    "id": 1090,
                    "text": "Pay off credit card debt",
                    "count": 5
                  },
                  {
                    "id": 1091,
                    "text": "Save the money",
                    "count": 3
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-lines-of-credit.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "28aba4df-240c-4567-82fe-26aea9faf1a2",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 66,
            "questions": [
              {
                "id": 266,
                "text": "You own a computer parts store and employ three people. You’ve completed several projects and are expecting funds in your account within a week. But, it’s the end of the month and your employees need to be paid. You don’ t have enough in your account to pay them.\nHow would you pay your employees?",
                "answers": [
                  {
                    "id": 1057,
                    "text": "Lines of Credit",
                    "count": 200
                  },
                  {
                    "id": 1058,
                    "text": "Term Loans",
                    "count": 100
                  },
                  {
                    "id": 1059,
                    "text": "Business Credit Card",
                    "count": 320
                  }
                ]
              },
              {
                "id": 268,
                "text": "Two employees will be traveling to a trade show to demonstrate your newest product. They need to book their travel arrangements: flights, ground transportation, hotels, food, and a daily allowance.\nHow would you make the purchase?",
                "answers": [
                  {
                    "id": 1063,
                    "text": "Lines of Credit",
                    "count": 110
                  },
                  {
                    "id": 1064,
                    "text": "Term Loans",
                    "count": 155
                  },
                  {
                    "id": 1065,
                    "text": "Business Credit Card",
                    "count": 332
                  }
                ]
              },
              {
                "id": 267,
                "text": "You own a grocery store, and one of your vendors is offering a great deal on a line of shampoos that are suddenly very popular. The only caveat? You need to order it immediately!\nHow would you make the purchase?",
                "answers": [
                  {
                    "id": 1060,
                    "text": "Lines of Credit",
                    "count": 20
                  },
                  {
                    "id": 1061,
                    "text": "Term Loans",
                    "count": 60
                  },
                  {
                    "id": 1062,
                    "text": "Business Credit Card",
                    "count": 60
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-mortgage-modification.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "6d725c95-1c66-4faa-b51f-82b0247a5977",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 68,
            "questions": [
              {
                "id": 271,
                "text": "",
                "answers": [
                  {
                    "id": 1071,
                    "text": "Lower rate loan, shorter term",
                    "count": 5
                  },
                  {
                    "id": 1072,
                    "text": "Higher rate, shorter term",
                    "count": 2
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/wesb-p2.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "What other options would work for Ali so that his money is protected?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "A checking account",
                    "count": 10
                  },
                  {
                    "id": 1084,
                    "text": "A traditional savings account.",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A certificate of deposit (CD)",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A money market account (MMA)",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A special account for a minor",
                    "count": 3
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-alis-decision.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "6d725c95-1c66-4faa-b51f-82b0247a5977",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 68,
            "questions": [
              {
                "id": 271,
                "text": "In this scenario, is Ali the lender or the borrower?",
                "answers": [
                  {
                    "id": 1070,
                    "text": "Lender",
                    "count": 1000
                  },
                  {
                    "id": 1071,
                    "text": "Borrower",
                    "count": 300
                  }
                ]
              },
              {
                "id": 272,
                "text": "What factor is impacting the differences in the total amount of interest in these examples?",
                "answers": [
                  {
                    "id": 1073,
                    "text": "Principle amount of loan",
                    "count": 1000
                  },
                  {
                    "id": 1074,
                    "text": "Interest rate",
                    "count": 300
                  },
                  {
                    "id": 1070,
                    "text": "Term Loan",
                    "count": 1000
                  }
                ]
              },
              {
                "id": 273,
                "text": "Which option would ultimately cost the borrower, Ali, less money in interest?",
                "answers": [
                  {
                    "id": 1073,
                    "text": "Option A",
                    "count": 1000
                  },
                  {
                    "id": 1074,
                    "text": "Option B",
                    "count": 300
                  }
                ]
              },
              {
                "id": 274,
                "text": "Which option would give the borrower, Ali, more time to pay off the loan?",
                "answers": [
                  {
                    "id": 1073,
                    "text": "Option A",
                    "count": 500
                  },
                  {
                    "id": 1074,
                    "text": "Option B",
                    "count": 300
                  }
                ]
              },
              {
                "id": 275,
                "text": "Which option would give the borrower, Ali, more time to pay off the loan?",
                "answers": [
                  {
                    "id": 1073,
                    "text": "Option A",
                    "count": 500
                  },
                  {
                    "id": 1074,
                    "text": "Option B",
                    "count": 300
                  }
                ]
              },
              {
                "id": 276,
                "text": "Which option would give the borrower, Ali, more time to pay off the loan?",
                "answers": [
                  {
                    "id": 1073,
                    "text": "Option A",
                    "count": 500
                  },
                  {
                    "id": 1074,
                    "text": "Option B",
                    "count": 300
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/maintaining-healthy-credit.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "Have you ever lost a cell phone?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "YES",
                    "count": 1
                  },
                  {
                    "id": 1084,
                    "text": "NO",
                    "count": 3
                  }
                ]
              },
              {
                "id": 277,
                "text": "Have you ever thrown away or recycled bank statements?",
                "answers": [
                  {
                    "id": 1089,
                    "text": "YES",
                    "count": 1
                  },
                  {
                    "id": 1090,
                    "text": "NO",
                    "count": 5
                  }
                ]
              },
              {
                "id": 278,
                "text": "Have you ever thrown away or recycled medical bills?",
                "answers": [
                  {
                    "id": 1086,
                    "text": "YES",
                    "count": 5
                  },
                  {
                    "id": 1087,
                    "text": "NO",
                    "count": 1
                  }
                ]
              },
              {
                "id": 279,
                "text": "Have you ever thrown away or recycled tax statements?",
                "answers": [
                  {
                    "id": 1086,
                    "text": "YES",
                    "count": 7
                  },
                  {
                    "id": 1087,
                    "text": "NO",
                    "count": 4
                  }
                ]
              },
              {
                "id": 280,
                "text": "Have you ever thrown away or recycled credit card bills?",
                "answers": [
                  {
                    "id": 1086,
                    "text": "YES",
                    "count": 5
                  },
                  {
                    "id": 1087,
                    "text": "NO",
                    "count": 5
                  }
                ]
              },
              {
                "id": 281,
                "text": "Have you ever thrown away or recycled insurance bills?",
                "answers": [
                  {
                    "id": 1086,
                    "text": "YES",
                    "count": 4
                  },
                  {
                    "id": 1087,
                    "text": "NO",
                    "count": 1
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/slg05.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "sections": [
    {
      "id": "1",
      "questions": [
        {
          "id": "2",
          "answers": [
            {
              "id": "3",
              "count": "8",
              "text": "ans1"
            },
            {
              "id": "33",
              "count": "1",
              "text": "ans2"
            },
            {
              "id": "333",
              "count": "5",
              "text": "ans3"
            }
          ]
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/poll_results/scenarios-joe-shop-positive-cash.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "6d725c95-1c66-4faa-b51f-82b0247a5977",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 68,
            "questions": [
              {
                "id": 271,
                "text": "Is Joe's T-Shirt Shop profitable?",
                "answers": [
                  {
                    "id": 1070,
                    "text": "Yes",
                    "count": 1000
                  },
                  {
                    "id": 1071,
                    "text": "No",
                    "count": 300
                  }
                ]
              },
              {
                "id": 272,
                "text": "Has Joe's T-Shirt Print Shop earned more revenue than what they spent on production costs?",
                "answers": [
                  {
                    "id": 1070,
                    "text": "Yes",
                    "count": 1000
                  },
                  {
                    "id": 1071,
                    "text": "No",
                    "count": 300
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/what-is-a-business-plan.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "1. Could ideas on a napkin be a business plan?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "Yes",
                    "count": 10
                  },
                  {
                    "id": 1084,
                    "text": "No",
                    "count": 1
                  }
                ]
              },
              {
                "id": 277,
                "text": "2. Could a one-page document be a business plan?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "Yes",
                    "count": 10
                  },
                  {
                    "id": 1084,
                    "text": "No",
                    "count": 50
                  }
                ]
              },
              {
                "id": 278,
                "text": "3. Could a 30-page document be a business plan?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "Yes",
                    "count": 15
                  },
                  {
                    "id": 1084,
                    "text": "No",
                    "count": 35
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/slg15.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "sections": [
    {
      "id": "1",
      "questions": [
        {
          "id": "1",
          "text": "Character",
          "answers": [
            {
              "id": "3",
              "count": "8",
              "flag": "op1"
            },
            {
              "id": "3",
              "count": "1",
              "flag": "op1"
            }
          ]
        },
        {
          "id": "2",
          "text": "Capacity",
          "answers": [
            {
              "id": "4",
              "count": "4",
              "flag": "op1"
            },
            {
              "id": "4",
              "count": "1",
              "flag": "op1"
            }
          ]
        },
        {
          "id": "3",
          "text": "Capital",
          "answers": [
            {
              "id": "3",
              "count": "4",
              "flag": "op1"
            },
            {
              "id": "3",
              "count": "2",
              "flag": "op1"
            }

          ]
        },
        {
          "id": "4",
          "text": "Collateral",
          "answers": [
            {
              "id": "4",
              "count": "3",
              "flag": "op4"
            },

             {
              "id": "3",
              "count": "2",
              "flag": "op1"
            }
          ]
        },

        {
          "id": "5",
          "text": "Conditions",
          "answers": [
            {
              "id": "7",
              "count": "2",
              "flag": "op5"
            },

            {
              "id": "3",
              "count": "2",
              "flag": "op1"
            }
          ]
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/poll_results/slg07.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "sections": [
    {
      "id": "1",
      "questions": [
        {
          "id": "2",
          "answers": [
            {
              "id": "3",
              "count": "8",
              "text": "ans1"
            },
            {
              "id": "33",
              "count": "1",
              "text": "ans2"
            },
            {
              "id": "333",
              "count": "5",
              "text": "ans3"
            }
          ]
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/poll_results/scenarios-types-of-accounts.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "6d725c95-1c66-4faa-b51f-82b0247a5977",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 68,
            "questions": [
              {
                "id": 271,
                "text": "What’s the best type of account for Jovena?",
                "answers": [
                  {
                    "id": 1070,
                    "text": "Payroll Account",
                    "count": 1000
                  },
                  {
                    "id": 1071,
                    "text": "Small Business Checking Account",
                    "count": 300
                  },
                  {
                    "id": 1072,
                    "text": "Certificates of Deposit",
                    "count": 300
                  }
                ]
              },
              {
                "id": 272,
                "text": "What’s the best type of account for Joe?",
                "answers": [
                  {
                    "id": 1073,
                    "text": "Payroll Account",
                    "count": 1000
                  },
                  {
                    "id": 1074,
                    "text": "Small Business Checking Account",
                    "count": 300
                  },
                  {
                    "id": 1070,
                    "text": "Commercial Checking Account",
                    "count": 1000
                  }
                ]
              },
              {
                "id": 273,
                "text": "What’s the best type of account for the Carter brothers?",
                "answers": [
                  {
                    "id": 1073,
                    "text": "Savings Account",
                    "count": 1000
                  },
                  {
                    "id": 1074,
                    "text": "Small Business Checking Account ",
                    "count": 300
                  },
                  {
                    "id": 1075,
                    "text": "Commercial Checking Account",
                    "count": 300
                  }
                ]
              },
              {
                "id": 274,
                "text": "Which option would give the borrower, Ali, more time to pay off the loan?",
                "answers": [
                  {
                    "id": 1073,
                    "text": "Option A",
                    "count": 500
                  },
                  {
                    "id": 1074,
                    "text": "Option B",
                    "count": 300
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-joans-retirement.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4924",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 79,
            "questions": [
              {
                "id": 300,
                "text": "Which chart best describes how her money will grow over 40 years?",
                "answers": [
                  {
                    "id": 1200,
                    "text": "Chart A",
                    "count": 1
                  },
                  {
                    "id": 1201,
                    "text": "Chart B",
                    "count": 5
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/financial-emergency2.json", function(exports, require, module) {
  module.exports = (function() {
return {
    "data": {
      "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
      "type": "poll_results",
      "attributes": {
        "results": {
          "sections": [
            {
              "id": 68,
              "questions": [
                {
                  "id": 269,
                  "text": "What does the average person pay for a health-related emergency?",
                  "answers": [
                    {
                      "id": 1064,
                      "text": "$250",
                      "count": 30
                    },
                    {
                      "id": 1065,
                      "text": "$500",
                      "count": 50
                    },
                    {
                      "id": "1066",
                      "text": "$1,200",
                      "count": 85
                    },
                    {
                      "id": "1067",
                      "text": "Trick question",
                      "count": 40
                    }
                  ]
                },
                {
                  "id": 270,
                  "text": "What is the average cost of an emergency home repair?",
                  "answers": [
                    {
                      "id": 1068,
                      "text": "About $1,000",
                      "count": 90
                    },
                    {
                      "id": 1069,
                      "text": "About $750",
                      "count": 50
                    },
                    {
                      "id": "1070",
                      "text": "About $500",
                      "count": 20
                    },
                    {
                      "id": "1071",
                      "text": "About $120",
                      "count": 10
                    }
                  ]
                },
                {
                  "id": 271,
                  "text": "After an unexpected job loss, how long does it take the average person to get a new job?",
                  "answers": [
                    {
                      "id": 1064,
                      "text": "1-2 months",
                      "count": 30
                    },
                    {
                      "id": 1065,
                      "text": "2-3 months",
                      "count": 50
                    },
                    {
                      "id": "1066",
                      "text": "3-6 months",
                      "count": 85
                    },
                    {
                      "id": "1067",
                      "text": "6-12 months",
                      "count": 40
                    }
                  ]
                }
              ]
            }
          ]
        }
      }
    }
  }

  })();
});

require.register("local-data/poll_results/scenarios-busy-parent.json", function(exports, require, module) {
  module.exports = (function() {
return {
    "data": {
      "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
      "type": "poll_results",
      "attributes": {
        "results": {
          "sections": [
            {
              "id": 68,
              "questions": [
                {
                  "id": 271,
                  "text": "There’s a correlation between mobile banking use and e-commerce fraud.",
                  "answers": [
                    {
                      "id": 1070,
                      "text": "True",
                      "count": 20
                    },
                    {
                      "id": 1071,
                      "text": "False",
                      "count": 80
                    }
                  ]
                },
                {
                  "id": 272,
                  "text": "Whenever customers access sensitive personally identifiable information (PII) via mobile banking, they put themselves at risk of identity theft.",
                  "answers": [
                    {
                      "id": 1070,
                      "text": "True",
                      "count": 30
                    },
                    {
                      "id": 1071,
                      "text": "False",
                      "count": 70
                    }
                  ]
                },
                {
                  "id": 273,
                  "text": "Consumers are more susceptible to making spur of the moment, or impulse purchases when using mobile banking.",
                  "answers": [
                    {
                      "id": 1070,
                      "text": "True",
                      "count": 25
                    },
                    {
                      "id": 1071,
                      "text": "False",
                      "count": 75
                    }
                  ]
                },
                {
                  "id": 274,
                  "text": "From June to August 2019, an average of $160,000 fraudulent transactions per month were reported by businesses, including retail and eCommerce sites.",
                  "answers": [
                    {
                      "id": 1070,
                      "text": "True",
                      "count": 20
                    },
                    {
                      "id": 1071,
                      "text": "False",
                      "count": 80
                    }
                  
                  ]
                }
              ]
            }
          ]
        }
      }
    }
  }
  
  })();
});

require.register("local-data/poll_results/slg13.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": "1",
            "questions": [
              {
                "id": "1",
                "text": "I save some money per month",
                "answers": [
                  {
                    "id": "3",
                    "count": "4",
                    "text": "YES",
                    "flag": "op1"
                  },
                  {
                    "id": "33",
                    "count": "5",
                    "text": "NO",
                    "flag": "op2"
                  }
                ]
              },
              {
                "id": "2",
                "text": "I know about savings accounts ",
                "answers": [
                  {
                    "id": "3",
                    "count": "4",
                    "text": "YES",
                    "flag": "op1"
                  },
                  {
                    "id": "33",
                    "count": "6",
                    "text": "NO",
                    "flag": "op2"
                  }
                ]
              },
              {
                "id": "3",
                "text": "I want to speak with a financial institution to learn more ",
                "answers": [
                  {
                    "id": "3",
                    "count": "2",
                    "text": "YES",
                    "flag": "op1"
                  },
                  {
                    "id": "33",
                    "count": "5",
                    "text": "NO",
                    "flag": "op2"
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/buying-a-car-s1-p10.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "28aba4df-240c-4567-82fe-26aea9faf1a2",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 68,
            "questions": [
              {
                "id": 269,
                "text": "What do you think the average cost of owning a vehicle comes out to each month?",
                "answers": [
                  {
                    "id": 1064,
                    "text": "$500",
                    "count": 75
                  },
                  {
                    "id": 1065,
                    "text": "$225",
                    "count": 100
                  },
                  {
                    "id": 1066,
                    "text": "$100",
                    "count": 50
                  },
                  {
                    "id": 1067,
                    "text": "$825",
                    "count": 25
                  }
                ]
              }
            ]
          },
          {
            "id": 69,
            "questions": [
              {
                "id": 270,
                "text": "Do you drive more than 10,000 miles per year?",
                "answers": [
                  {
                    "id": 1068,
                    "text": "Yes",
                    "count": 75
                  },
                  {
                    "id": 1069,
                    "text": "No",
                    "count": 100
                  }
                ]
              }
            ]
          },
          {
            "id": 70,
            "questions": [
              {
                "id": 274,
                "text": "Who do you think got the better deal, Thomas or Sari?",
                "answers": [
                  {
                    "id": 1070,
                    "text": "Thomas",
                    "count": 75
                  },
                  {
                    "id": 1071,
                    "text": "Sari",
                    "count": 100
                  }
                ]
              }
            ]
          },
          {
            "id": 71,
            "questions": [
              {
                "id": 275,
                "text": "Can Lane afford her dream car based on the 20/4/10 Rule?",
                "answers": [
                  {
                    "id": 1068,
                    "text": "Yes",
                    "count": 75
                  },
                  {
                    "id": 1069,
                    "text": "No",
                    "count": 100
                  }
                ]
              }
            ]
          },
          {
            "id": 72,
            "questions": [
              {
                "id": 275,
                "text": "Do you feel you learned more about buying a car after taking this course?",
                "answers": [
                  {
                    "id": 1068,
                    "text": "Yes",
                    "count": 75
                  },
                  {
                    "id": 1069,
                    "text": "No",
                    "count": 100
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/scenarios-joe-shop-balance-sheet.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4924",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 79,
            "questions": [
              {
                "id": 300,
                "text": "Does Joe have enough working capital to cover the costs of the Solis Software order upfront?",
                "answers": [
                  {
                    "id": 1200,
                    "text": "Yes",
                    "count": 1
                  },
                  {
                    "id": 1201,
                    "text": "No",
                    "count": 5
                  }
                ]
              },
              {
                "id": 301,
                "text": "Should he draw on his Line of Credit? ",
                "answers": [
                  {
                    "id": 1200,
                    "text": "Yes",
                    "count": 4
                  },
                  {
                    "id": 1201,
                    "text": "No",
                    "count": 1
                  }
                ]
              },
              {
                "id": 302,
                "text": "Is Joe’s Shop in a positive “equity position”?",
                "answers": [
                  {
                    "id": 1200,
                    "text": "Yes",
                    "count": 5
                  },
                  {
                    "id": 1201,
                    "text": "No",
                    "count": 3
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/pros-and-cons.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": "1",
            "questions": [
              {
                "id": "1",
                "text": "A home has long term value.",
                "answers": [
                  {
                    "id": "3",
                    "count": "8",
                    "text": "PRO",
                    "flag": "op1"
                  },
                  {
                    "id": "33",
                    "count": "1",
                    "text": "CON",
                    "flag": "op2"
                  }
                ]
              },
              {
                "id": "2",
                "text": "You need to make payments towards a home.",
                "answers": [
                  {
                    "id": "3",
                    "count": "4",
                    "text": "PRO",
                    "flag": "op1"
                  },
                  {
                    "id": "33",
                    "count": "2",
                    "text": "CON",
                    "flag": "op2"
                  }
                ]
              },
              {
                "id": "3",
                "text": "You may need to pay taxes on the home.",
                "answers": [
                  {
                    "id": "3",
                    "count": "2",
                    "text": "PRO",
                    "flag": "op1"
                  },
                  {
                    "id": "33",
                    "count": "5",
                    "text": "CON",
                    "flag": "op2"
                  }
                ]
              },
              {
                "id": "4",
                "text": "You can remodel the home any way you like.",
                "answers": [
                  {
                    "id": "3",
                    "count": "2",
                    "text": "PRO",
                    "flag": "op1"
                  },
                  {
                    "id": "33",
                    "count": "5",
                    "text": "CON",
                    "flag": "op2"
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/kaylees-debt-repayment-strategy.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "kaylees-debt-repayment-strategy_pollResult",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": "EX_POLL_RESULT_SECTION_ID_1",
            "questions": [
              {
                "id": "EX_QUES_1",
                "text": "Using the Snowball Method, which debt should Kaylee pay off first?",
                "answers": [
                  {
                    "id": "EX_ANS_1",
                    "text": "Major credit card",
                    "count": 21312
                  },
                  {
                    "id": "EX_ANS_2",
                    "text": "Store credit card",
                    "count": 9344
                  },
                  {
                    "id": "EX_ANS_3",
                    "text": "Personal loan",
                    "count": 689
                  }
                ]
              },
              {
                "id": "EX_QUES_2",
                "text": "Using the Avalanche Method, which debt should Kaylee pay off first",
                "answers": [
                  {
                    "id": "EX_ANS_1",
                    "text": "Major credit card",
                    "count": 21312
                  },
                  {
                    "id": "EX_ANS_2",
                    "text": "Store credit card",
                    "count": 9344
                  },
                  {
                    "id": "EX_ANS_3",
                    "text": "Personal loan",
                    "count": 689
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
  })();
});

require.register("local-data/poll_results/slg04.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "sections": [
    {
      "id": "1",
      "questions": [
        {
          "id": "2",
          "answers": [
            {
              "id": "3",
              "count": "8",
              "text": "ans1"
            },
            {
              "id": "33",
              "count": "1",
              "text": "ans2"
            },
            {
              "id": "333",
              "count": "5",
              "text": "ans3"
            }
          ]
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/poll_results/wesb-p1.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "What other options would work for Ali so that his money is protected?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "A checking account",
                    "count": 10
                  },
                  {
                    "id": 1084,
                    "text": "A traditional savings account.",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A certificate of deposit (CD)",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A money market account (MMA)",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A special account for a minor",
                    "count": 3
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/slg08.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "sections": [
    {
      "id": "1",
      "questions": [
        {
          "id": "2",
          "answers": [
            {
              "id": "3",
              "count": "8",
              "text": "ans1"
            },
            {
              "id": "33",
              "count": "1",
              "text": "ans2"
            },
            {
              "id": "333",
              "count": "5",
              "text": "ans3"
            }
          ]
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/poll_results/financial-emergency3.json", function(exports, require, module) {
  module.exports = (function() {
return {
    "data": {
      "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
      "type": "poll_results",
      "attributes": {
        "results": {
          "sections": [
            {
              "id": 68,
              "questions": [
                {
                  "id": 269,
                  "text": "Do you feel like you have gained knowledge on how to prepare for a financial emergency after taking this course?",
                  "answers": [
                    {
                      "id": 1064,
                      "text": "Yes",
                      "count": 98
                    },
                    {
                      "id": 1065,
                      "text": "No",
                      "count": 2
                    }
                  ]
                }
              ]
            }
          ]
        }
      }
    }
  }

  })();
});

require.register("local-data/poll_results/slg16.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": "1",
            "questions": [
              {
                "id": "1",
                "text": "I keep a record of what I earn each month",
                "answers": [
                  {
                    "id": "3",
                    "count": "8",
                    "text": "YES",
                    "flag": "op1"
                  },
                  {
                    "id": "33",
                    "count": "1",
                    "text": "NO",
                    "flag": "op2"
                  }
                ]
              },
              {
                "id": "2",
                "text": "I keep a record of what I spend each month ",
                "answers": [
                  {
                    "id": "3",
                    "count": "4",
                    "text": "YES",
                    "flag": "op1"
                  },
                  {
                    "id": "33",
                    "count": "6",
                    "text": "NO",
                    "flag": "op2"
                  }
                ]
              },
              {
                "id": "3",
                "text": "I keep a record of what I save each month ",
                "answers": [
                  {
                    "id": "3",
                    "count": "2",
                    "text": "YES",
                    "flag": "op1"
                  },
                  {
                    "id": "33",
                    "count": "5",
                    "text": "NO",
                    "flag": "op2"
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/wesb-p4.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "What other options would work for Ali so that his money is protected?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "A checking account",
                    "count": 10
                  },
                  {
                    "id": 1084,
                    "text": "A traditional savings account.",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A certificate of deposit (CD)",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A money market account (MMA)",
                    "count": 3
                  },
                  {
                    "id": 1084,
                    "text": "A special account for a minor",
                    "count": 3
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/slg01.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "sections": [
    {
      "id": "1",
      "questions": [
        {
          "id": "2",
          "answers": [
            {
              "id": "3",
              "count": "8",
              "text": "ans1"
            },
            {
              "id": "33",
              "count": "1",
              "text": "ans2"
            },
            {
              "id": "333",
              "count": "5",
              "text": "ans3"
            }
          ]
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/poll_results/scenarios-budgeting-for-mortgage.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "28aba4df-240c-4567-82fe-26aea9faf1a2",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [{
          "id": 66,
          "questions": [{
            "id": 269,
            "text": "I keep a record of what I earn each month.",
            "answers": [{
                "id": 1064,
                "text": "Yes",
                "count": 200
              }, 
              {
                "id": 1065,
                "text": "No",
                "count": 100
              }
            ]
          },
          {
            "id": 271,
            "text": "I keep a record of what I spend each month.",
            "answers": [{
                "id": 1064,
                "text": "Yes",
                "count": 200
              }, 
              {
                "id": 1065,
                "text": "No",
                "count": 50
              }
            ]
          },
          {
            "id": 272,
            "text": "I keep a record of what I save each month.",
            "answers": [{
                "id": 1064,
                "text": "Yes",
                "count": 50
              }, 
              {
                "id": 1065,
                "text": "No",
                "count": 200
              }
            ]
          }]
        }]
      }
    }
  }
}
  })();
});

require.register("local-data/poll_results/who-got-the-best-financial-deal.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "poll_results",
    "attributes": {
      "results": {
        "sections": [
          {
            "id": 71,
            "questions": [
              {
                "id": 276,
                "text": "What other options would work for Ali so that his money is protected?",
                "answers": [
                  {
                    "id": 1083,
                    "text": "Min ho", 
                    "count": 10
                  },
                  {
                    "id": 1084,
                    "text": "Javier",
                    "count": 20
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}

  })();
});

require.register("local-data/poll_results/slg09.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "sections": [
    {
      "id": "1",
      "questions": [
        {
          "id": "2",
          "answers": [
            {
              "id": "3",
              "count": "8",
              "text": "ans1"
            },
            {
              "id": "33",
              "count": "1",
              "text": "ans2"
            }
          ]
        }
      ]
    }
  ]
}

  })();
});

require.register("local-data/customizations.json", function(exports, require, module) {
  module.exports = (function() {
return [
  {
    "type": "css-customization",
    "primary_color": "#FDBB39",
    "secondary_color": "#002E6D"
  }
]
  })();
});

require.register("local-data/resources.json", function(exports, require, module) {
  module.exports = (function() {
return [
  {
    "id": 68,
    "type": "PolicyResource",
    "sub_type": "Alcohol Policy",
    "default": false,
    "name": "A blank test test",
    "url": "",
    "body": "aa",
    "requires_e_signature": false
  }
]
  })();
});

require.register("local-data/polls/scenarios-budget-plan.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "68",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-budget-plan",
        "name": "Using Business cards: Scenarios Poll",
        "description": "Using Business card: Scenarios",
        "title": "Using Business card: Scenarios",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "68",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Using Business card: Scenarios",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "272",
              "type": "response_set_questions"
            },
            {
              "id": "273",
              "type": "response_set_questions"
            },
            {
              "id": "274",
              "type": "response_set_questions"
            },
            {
              "id": "275",
              "type": "response_set_questions"
            },
            {
              "id": "276",
              "type": "response_set_questions"
            },
            {
              "id": "277",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "What is Marta's monthly income?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1070",
              "type": "answers"
            },
            {
              "id": "1071",
              "type": "answers"
            },
            {
              "id": "1072",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "272",
      "type": "response_set_questions",
      "attributes": {
        "text": "What is the total amount of Marta’s needs?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1070",
              "type": "answers"
            },
            {
              "id": "1073",
              "type": "answers"
            },
            {
              "id": "1074",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "273",
      "type": "response_set_questions",
      "attributes": {
        "text": "If Marta’s monthly income is $2,000 and her needs total $1,220, what is Marta’s disposable income?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1073",
              "type": "answers"
            },
            {
              "id": "1075",
              "type": "answers"
            },
            {
              "id": "1072",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "274",
      "type": "response_set_questions",
      "attributes": {
        "text": "What is the total amount of Marta’s wants?",
        "active": true,
        "shuffle": false,
        "position": 4,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1076",
              "type": "answers"
            },
            {
              "id": "1077",
              "type": "answers"
            },
            {
              "id": "1078",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "275",
      "type": "response_set_questions",
      "attributes": {
        "text": "Marta’s disposable income is $780. If she spends $210 on her wants, how much will she have left?",
        "active": true,
        "shuffle": false,
        "position": 5,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1079",
              "type": "answers"
            },
            {
              "id": "1080",
              "type": "answers"
            },
            {
              "id": "1081",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "276",
      "type": "response_set_questions",
      "attributes": {
        "text": "Marta wants to contribute $100 of her $570 of disposable income to her savings account. How much is she left with?",
        "active": true,
        "shuffle": false,
        "position": 5,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1082",
              "type": "answers"
            },
            {
              "id": "1083",
              "type": "answers"
            },
            {
              "id": "1084",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "277",
      "type": "response_set_questions",
      "attributes": {
        "text": "How much does Marta pay to her debts each month?",
        "active": true,
        "shuffle": false,
        "position": 5,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1085",
              "type": "answers"
            },
            {
              "id": "1086",
              "type": "answers"
            },
            {
              "id": "1087",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1070",
      "type": "answers",
      "attributes": {
        "text": "$1000",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1071",
      "type": "answers",
      "attributes": {
        "text": "$3000",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1072",
      "type": "answers",
      "attributes": {
        "text": "$2000",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1073",
      "type": "answers",
      "attributes": {
        "text": "$1220",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1074",
      "type": "answers",
      "attributes": {
        "text": "$2200",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1075",
      "type": "answers",
      "attributes": {
        "text": "$780",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1076",
      "type": "answers",
      "attributes": {
        "text": "$110",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1077",
      "type": "answers",
      "attributes": {
        "text": "$210",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1078",
      "type": "answers",
      "attributes": {
        "text": "$310",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1079",
      "type": "answers",
      "attributes": {
        "text": "$270",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1080",
      "type": "answers",
      "attributes": {
        "text": "$370",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1081",
      "type": "answers",
      "attributes": {
        "text": "$470",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1082",
      "type": "answers",
      "attributes": {
        "text": "$270",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1083",
      "type": "answers",
      "attributes": {
        "text": "$370",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1084",
      "type": "answers",
      "attributes": {
        "text": "$470",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1085",
      "type": "answers",
      "attributes": {
        "text": "$7000",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1086",
      "type": "answers",
      "attributes": {
        "text": "$200",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1087",
      "type": "answers",
      "attributes": {
        "text": "$300",
        "active": true,
        "position": 3
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-identity-theft.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-identity-theft",
        "name": "Scenario Identity theft",
        "description": "Scenario Identity theft",
        "title": "Scenario Identity theft",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Scenario Identity theft",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "272",
              "type": "response_set_questions"
            },
            {
              "id": "273",
              "type": "response_set_questions"
            },
            {
              "id": "274",
              "type": "response_set_questions"
            },
            {
              "id": "275",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "Have you ever lost a cell phone?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "Have you ever thrown away or recycled bank statements?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "272",
      "type": "response_set_questions",
      "attributes": {
        "text": "Have you ever thrown away or recycled medical bills?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "273",
      "type": "response_set_questions",
      "attributes": {
        "text": "Have you ever thrown away or recycled tax statements?",
        "active": true,
        "shuffle": false,
        "position": 4,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "274",
      "type": "response_set_questions",
      "attributes": {
        "text": "Have you ever thrown away or recycled credit card bills?",
        "active": true,
        "shuffle": false,
        "position": 5,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "275",
      "type": "response_set_questions",
      "attributes": {
        "text": "Have you ever thrown away or recycled insurance bills?",
        "active": true,
        "shuffle": false,
        "position": 6,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "276",
      "type": "response_set_questions",
      "attributes": {
        "text": "Have you ever thrown away or recycled insurance bills?",
        "active": true,
        "shuffle": false,
        "position": 7,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "Yes",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "No",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/emily-financial-burden.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "emily-financial-burden",
        "name": "Credit Score and Report",
        "description": "Credit Score and Report",
        "title": "Credit Score and Report",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Rooftop Repair Quiz",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "270",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "What change can Emily make to her budget to make the most impact? ",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            },
            {
              "id": "1067",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "270",
      "type": "response_set_questions",
      "attributes": {
        "text": "What other debt management strategies can Emily use?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1068",
              "type": "answers"
            },
            {
              "id": "1069",
              "type": "answers"
            },
            {
              "id": "1070",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "Who got the best financial deal?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1070",
              "type": "answers"
            },
            {
              "id": "1071",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "Reduce her spending overall",
        "active": true,
        "position": 0
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "Get a more affordable cell phone or cable plan",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "Reduce gas by carpooling",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1067",
      "type": "answers",
      "attributes": {
        "text": "Spend less on clothing, shoes, and hair",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1068",
      "type": "answers",
      "attributes": {
        "text": "Discuss getting a reduced APR with creditors",
        "active": true,
        "position": 0
      }
    },
    {
      "id": "1069",
      "type": "answers",
      "attributes": {
        "text": "Consolidate student loans",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1070",
      "type": "answers",
      "attributes": {
        "text": "Javier",
        "active": true,
        "position": 0
      }
    },
    {
      "id": "1071",
      "type": "answers",
      "attributes": {
        "text": "Min Ho",
        "active": true,
        "position": 1
      }
    }    
  ]
}

  })();
});

require.register("local-data/polls/scenarios-financial-action-plan.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-financial-action-plan",
        "name": "Financial Action Plan: Scenarios",
        "description": "Financial Action Plan: Scenarios",
        "title": "Financial Action Plan: Scenarios",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Financial Action Plan: Scenarios",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "270",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "Which of the following best describes you?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "I save some money per month",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "I know about savings accounts",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "I want to speak with a financial institution to learn more",
        "active": true,
        "position": 3
      }
    }
  ]
}
  })();
});

require.register("local-data/polls/debt-management-what-you-learned.json", function(exports, require, module) {
  module.exports = (function() {
return {
    "data": {
        "id": "debt-management-what-you-learned_poll",
        "type": "response_sets",
        "attributes": {
            "time_taken": null,
            "fields": {},
            "answers": [
                {
                    "question_id": "EX_POLL_QUES_1",
                    "value": "EX_POLL_ANS_1",
                    "response_type": "single_selection"
                }
            ],
            "current_section_id": 68,
            "grade": null,
            "status": "started",
            "web_hooks": {},
            "evaluation_has_started": false
        },
        "relationships": {
            "evaluation": {
                "data": {
                    "id": "68",
                    "type": "evaluations"
                }
            },
            "sections": {
                "data": [
                    {
                        "id": "68",
                        "type": "response_set_sections"
                    }
                ]
            }
        }
    },
    "included": [
        {
            "id": "68",
            "type": "evaluations",
            "attributes": {
                "slug": "debt-management-what-you-learned",
                "name": "Survey! What You Learned",
                "description": "",
                "title": "Survey! What You Learned",
                "active": true,
                "intro_text": null,
                "passed_text": null,
                "failure_text": null,
                "start_date": "2017-09-01",
                "end_date": "2018-09-01",
                "passing_grade": 0,
                "show_results_screen": false,
                "shuffle": false,
                "hide_grade": false,
                "show_intro": true
            },
            "relationships": {
                "sections": {
                    "data": [
                        {
                            "id": "68",
                            "type": "sections"
                        }
                    ]
                }
            }
        },
        {
            "id": "68",
            "type": "response_set_sections",
            "attributes": {
                "title": "Survey! What You Learned",
                "active": true,
                "shuffle": false,
                "bank": false,
                "bank_count": null,
                "position": 1,
                "completed": false
            },
            "relationships": {
                "questions": {
                    "data": [
                        {
                            "id": "EX_POLL_QUES_1",
                            "type": "response_set_questions"
                        }
                    ]
                }
            }
        },
        {
            "id": "EX_POLL_QUES_1",
            "type": "response_set_questions",
            "attributes": {
                "text": "Do you feel like you know more about debt and debt management strategies than before you started this course?",
                "active": true,
                "shuffle": false,
                "position": 1,
                "responded": true
            },
            "relationships": {
                "answers": {
                    "data": [
                        {
                            "id": "EX_POLL_ANS_1",
                            "type": "answers"
                        },
                        {
                            "id": "EX_POLL_ANS_2",
                            "type": "answers"
                        }
                    ]
                }
            }
        },
        {
            "id": "EX_POLL_ANS_1",
            "type": "answers",
            "attributes": {
                "text": "Yes",
                "active": true,
                "position": 1
            }
        },
        {
            "id": "EX_POLL_ANS_2",
            "type": "answers",
            "attributes": {
                "text": "No",
                "active": true,
                "position": 2
            }
        }
    ]
}
  })();
});

require.register("local-data/polls/scenarios-credit-scams.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [],
      "current_section_id": 71,
      "grade": null,
      "status": "created",
      "web_hooks": {
        "completed": "http://content-service.dev:5001/api/v1/response_sets/ad5000d0-5649-4e14-8c11-33f879a885fb/complete"
      },
      "evaluation_has_started": true
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "71",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "71",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "71",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-credit-scams",
        "name": "Credit Repair Scams",
        "description": "Credit Repair Scams",
        "title": "Credit Repair Scams",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "71",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "71",
      "type": "response_set_sections",
      "attributes": {
        "title": "Credit Repair Scams",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "276",
              "type": "response_set_questions"
            },
            {
              "id": "277",
              "type": "response_set_questions"
            },
            {
              "id": "278",
              "type": "response_set_questions"
            },
            {
              "id": "279",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "276",
      "type": "response_set_questions",
      "attributes": {
        "text": "Does this raise a red flag?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1083",
              "type": "answers"
            },
            {
              "id": "1084",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1083",
      "type": "answers",
      "attributes": {
        "text": "YES",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1084",
      "type": "answers",
      "attributes": {
        "text": "NO",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "277",
      "type": "response_set_questions",
      "attributes": {
        "text": "Does this raise a red flag?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1089",
              "type": "answers"
            },
            {
              "id": "1090",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1089",
      "type": "answers",
      "attributes": {
        "text": "YES",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1090",
      "type": "answers",
      "attributes": {
        "text": "NO",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "278",
      "type": "response_set_questions",
      "attributes": {
        "text": "Does this raise a red flag?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1086",
              "type": "answers"
            },
            {
              "id": "1087",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1086",
      "type": "answers",
      "attributes": {
        "text": "YES",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1087",
      "type": "answers",
      "attributes": {
        "text": "NO",
        "active": true,
        "position": 2
      }
    }
    ,
    {
      "id": "279",
      "type": "response_set_questions",
      "attributes": {
        "text": "Does this raise a red flag?",
        "active": true,
        "shuffle": false,
        "position": 4,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1086",
              "type": "answers"
            },
            {
              "id": "1087",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1086",
      "type": "answers",
      "attributes": {
        "text": "YES",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1087",
      "type": "answers",
      "attributes": {
        "text": "NO",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/poll-result-example.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "EX_POLL_ID",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": "EX_POLL_QUES_1",
          "value": "EX_POLL_ANS_1",
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "68",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "poll-result-example",
        "name": "Leading Source of Debt",
        "description": "",
        "title": "What is the leading source of debt in America?",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "68",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "What is the leading source of debt in America?",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "EX_POLL_QUES_1",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "EX_POLL_QUES_1",
      "type": "response_set_questions",
      "attributes": {
        "text": "What is the leading source of debt in America?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "EX_POLL_ANS_1",
              "type": "answers"
            },
            {
              "id": "EX_POLL_ANS_2",
              "type": "answers"
            },
            {
              "id": "EX_POLL_ANS_3",
              "type": "answers"
            },
            {
              "id": "EX_POLL_ANS_4",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "EX_POLL_ANS_1",
      "type": "answers",
      "attributes": {
        "text": "Mortgage debt",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "EX_POLL_ANS_2",
      "type": "answers",
      "attributes": {
        "text": "Student loan debt",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "EX_POLL_ANS_3",
      "type": "answers",
      "attributes": {
        "text": "Credit card debt",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "EX_POLL_ANS_4",
      "type": "answers",
      "attributes": {
        "text": "Car loan debt",
        "active": true,
        "position": 4
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-cost-merging.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [],
      "current_section_id": 71,
      "grade": null,
      "status": "created",
      "web_hooks": {
        "completed": "http://content-service.dev:5001/api/v1/response_sets/ad5000d0-5649-4e14-8c11-33f879a885fb/complete"
      },
      "evaluation_has_started": true
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "71",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "71",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "71",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-cost-merging",
        "name": "The Cost of Merging Credit",
        "description": "The Cost of Merging Credit",
        "title": "The Cost of Merging Credit",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "71",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "71",
      "type": "response_set_sections",
      "attributes": {
        "title": "The Cost of Merging Credit",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "276",
              "type": "response_set_questions"
            },
            {
              "id": "277",
              "type": "response_set_questions"
            },
            {
              "id": "278",
              "type": "response_set_questions"
            },
            {
              "id": "279",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "276",
      "type": "response_set_questions",
      "attributes": {
        "text": "Will co-signing affect Bella’s credit score?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1083",
              "type": "answers"
            },
            {
              "id": "1084",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1083",
      "type": "answers",
      "attributes": {
        "text": "YES",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1084",
      "type": "answers",
      "attributes": {
        "text": "NO",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "277",
      "type": "response_set_questions",
      "attributes": {
        "text": "Will it affect her score positively or negatively?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1089",
              "type": "answers"
            },
            {
              "id": "1090",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1089",
      "type": "answers",
      "attributes": {
        "text": "POSITIVELY",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1090",
      "type": "answers",
      "attributes": {
        "text": "NEGATIVELY",
        "active": true,
        "position": 2
      }
    }
  ]
}
  })();
});

require.register("local-data/polls/martas-goals.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "types-of-accounts",
        "name": "Types of Accounts",
        "description": "How familiar are you with…",
        "title": "Types of Accounts",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Take a vacation",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "272",
              "type": "response_set_questions"
            },
            {
              "id": "273",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "Buy a new phone",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "Pay off credit cards",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
            "id": "1064",
            "type": "answers"
          },
          {
            "id": "1065",
            "type": "answers"
          },
          {
            "id": "1066",
            "type": "answers"
          }
          ]
        }
      }
    },
    {
      "id": "272",
      "type": "response_set_questions",
      "attributes": {
        "text": "Save for a down payment on a house",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
            "id": "1064",
            "type": "answers"
          },
          {
            "id": "1065",
            "type": "answers"
          },
          {
            "id": "1066",
            "type": "answers"
          }
          ]
        }
      }
    },
    {
      "id": "273",
      "type": "response_set_questions",
      "attributes": {
        "text": "Pay off student loans",
        "active": true,
        "shuffle": false,
        "position": 4,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
            "id": "1064",
            "type": "answers"
          },
          {
            "id": "1065",
            "type": "answers"
          },
          {
            "id": "1066",
            "type": "answers"
          }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "Short",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "Medium",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "Long",
        "active": true,
        "position": 3
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-joe-shop-line-credit-capital.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 79,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "79",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "79",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "79",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-joe-shop-enough-capital",
        "name": "Balance Sheet: Joe’s Shop",
        "description": "Balance Sheet: Joe’s Shop",
        "title": "Balance Sheet: Joe’s Shop",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "79",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "79",
      "type": "response_set_sections",
      "attributes": {
        "title": "Balance Sheet: Joe’s Shop",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "300",
              "type": "response_set_questions"
            },
            {
              "id": "301",
              "type": "response_set_questions"
            },
            {
              "id": "302",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "300",
      "type": "response_set_questions",
      "attributes": {
        "text": "",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1200",
              "type": "answers"
            },
            {
              "id": "1201",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "301",
      "type": "response_set_questions",
      "attributes": {
        "text": "",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1200",
              "type": "answers"
            },
            {
              "id": "1201",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "302",
      "type": "response_set_questions",
      "attributes": {
        "text": "",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1200",
              "type": "answers"
            },
            {
              "id": "1201",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1200",
      "type": "answers",
      "attributes": {
        "text": "YES",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1201",
      "type": "answers",
      "attributes": {
        "text": "NO",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-joe-shop-cash-flow.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 79,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "79",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "79",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "79",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-joe-shop-positive-cash",
        "name": "Cash Flow: Joe’s Shop",
        "description": "Cash Flow: Joe’s Shop",
        "title": "Cash Flow: Joe’s Shop",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "79",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "79",
      "type": "response_set_sections",
      "attributes": {
        "title": "Cash Flow: Joe’s Shop",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "300",
              "type": "response_set_questions"
            },
            {
              "id": "301",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "300",
      "type": "response_set_questions",
      "attributes": {
        "text": "Does Joe's T-Shirt Print Shop have a positive cash flow?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1200",
              "type": "answers"
            },
            {
              "id": "1201",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "301",
      "type": "response_set_questions",
      "attributes": {
        "text": "Does the cash flow statement for Joe's T-Shirt Print Shop support his decision to take out a loan to cover his short term cash needs?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1200",
              "type": "answers"
            },
            {
              "id": "1201",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1200",
      "type": "answers",
      "attributes": {
        "text": "Yes",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1201",
      "type": "answers",
      "attributes": {
        "text": "No",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-term-loan.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [],
      "current_section_id": 71,
      "grade": null,
      "status": "created",
      "web_hooks": {
        "completed": "http://content-service.dev:5001/api/v1/response_sets/ad5000d0-5649-4e14-8c11-33f879a885fb/complete"
      },
      "evaluation_has_started": true
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "71",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "71",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "71",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-term-loan",
        "name": "Term Loan: Scenarios Poll",
        "description": "Term Loan: Scenarios",
        "title": "Term Loan: Scenarios",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "71",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "71",
      "type": "response_set_sections",
      "attributes": {
        "title": "Term Loan: Scenarios",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "276",
              "type": "response_set_questions"
            },
            {
              "id": "278",
              "type": "response_set_questions"
            },
            {
              "id": "277",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "276",
      "type": "response_set_questions",
      "attributes": {
        "text": "What credit type do you need?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1083",
              "type": "answers"
            },
            {
              "id": "1084",
              "type": "answers"
            },
            {
              "id": "1085",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1083",
      "type": "answers",
      "attributes": {
        "text": "Unsecured Term Loan",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1084",
      "type": "answers",
      "attributes": {
        "text": "Real estate Secured Term Loan",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1085",
      "type": "answers",
      "attributes": {
        "text": "Non-real estate Secured Term Loan",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "278",
      "type": "response_set_questions",
      "attributes": {
        "text": "What credit type do you need?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1089",
              "type": "answers"
            },
            {
              "id": "1090",
              "type": "answers"
            },
            {
              "id": "1091",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1089",
      "type": "answers",
      "attributes": {
        "text": "Unsecured Term Loan",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1090",
      "type": "answers",
      "attributes": {
        "text": "Real Estate Secured Term Loan",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1091",
      "type": "answers",
      "attributes": {
        "text": "Non-real Estate Secured Term Loan",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "277",
      "type": "response_set_questions",
      "attributes": {
        "text": "What credit type do you need?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1086",
              "type": "answers"
            },
            {
              "id": "1087",
              "type": "answers"
            },
            {
              "id": "1088",
              "type": "answers"
            },
            {
              "id": "1092",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1086",
      "type": "answers",
      "attributes": {
        "text": "Unsecured Term Loan",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1087",
      "type": "answers",
      "attributes": {
        "text": "Real estate Secured Term Loan",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1088",
      "type": "answers",
      "attributes": {
        "text": "Non-real estate Secured Term Loan",
        "active": true,
        "position": 3
      }
    },

    {
      "id": "1092",
      "type": "answers",
      "attributes": {
        "text": "Line of Credit",
        "active": true,
        "position": 4
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/wesb-q3.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "protecting-money",
        "name": "Ali's Decision: Part 1",
        "description": "Ali's Decision: Part 1",
        "title": "Ali's Decision: Part 1",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Ali's Decision: Part 1",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "What other options would work for Ali so that his money is protected?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            },
            {
              "id": "1067",
              "type": "answers"
            },
            {
              "id": "1068",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "A checking account.",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "A traditional savings account.",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "A certificate of deposit (CD)",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1067",
      "type": "answers",
      "attributes": {
        "text": "A money market account (MMA)",
        "active": true,
        "position": 4
      }
    },
    {
      "id": "1068",
      "type": "answers",
      "attributes": {
        "text": "A special account for a minor",
        "active": true,
        "position": 5
      }
    }
  ]
}
  })();
});

require.register("local-data/polls/rooftop-repair-quiz.json", function(exports, require, module) {
  module.exports = (function() {
return {
    "data": {
      "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
      "type": "response_sets",
      "attributes": {
        "time_taken": null,
        "fields": {},
        "answers": [{
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }],
        "current_section_id": 68,
        "grade": null,
        "status": "started",
        "web_hooks": {},
        "evaluation_has_started": false
      },
      "relationships": {
        "evaluation": {
          "data": {
            "id": "68",
            "type": "evaluations"
          }
        },
        "sections": {
          "data": [{
            "id": "68",
            "type": "response_set_sections"
          }]
        }
      }
    },
    "included": [{
        "id": "68",
        "type": "evaluations",
        "attributes": {
          "slug": "rooftop-repair-quiz",
          "name": "Rooftop Repair Quiz",
          "description": "Rooftop Repair Quiz",
          "title": "Rooftop Repair Quiz",
          "active": true,
          "intro_text": null,
          "passed_text": null,
          "failure_text": null,
          "start_date": "2017-09-01",
          "end_date": "2018-09-01",
          "passing_grade": 0,
          "show_results_screen": false,
          "shuffle": false,
          "hide_grade": false,
          "show_intro": true
        },
        "relationships": {
          "sections": {
            "data": [{
              "id": "68",
              "type": "sections"
            }]
          }
        }
      },
      {
        "id": "68",
        "type": "response_set_sections",
        "attributes": {
          "title": "Rooftop Repair Quiz",
          "active": true,
          "shuffle": false,
          "bank": false,
          "bank_count": null,
          "position": 1,
          "completed": false
        },
        "relationships": {
          "questions": {
            "data": [{
                "id": "269",
                "type": "response_set_questions"
              },
              {
                "id": "270",
                "type": "response_set_questions"
              }
            ]
          }
        }
      },
      {
        "id": "269",
        "type": "response_set_questions",
        "attributes": {
          "text": "If Ralph makes a monthly payment of $50 per month on his credit card, how long will it take him to pay off the roof repair?",
          "active": true,
          "shuffle": false,
          "position": 1,
          "responded": true
        },
        "relationships": {
          "answers": {
            "data": [{
                "id": "1064",
                "type": "answers"
              },
              {
                "id": "1065",
                "type": "answers"
              },
              {
              "id": "1066",
              "type": "answers"
            }
            ]
          }
        }
      },
      {
        "id": "270",
        "type": "response_set_questions",
        "attributes": {
          "text": "What will the total cost of the repair cost Ralph if he only pays $50 per month?",
          "active": true,
          "shuffle": false,
          "position": 1,
          "responded": true
        },
        "relationships": {
          "answers": {
            "data": [{
                "id": "1067",
                "type": "answers"
              },
              {
                "id": "1068",
                "type": "answers"
              },
              {
              "id": "1069",
              "type": "answers"
            }
            ]
          }
        }
      },
      {
        "id": "1064",
        "type": "answers",
        "attributes": {
          "text": "135 months",
          "active": true,
          "position": 1
        }
      },
      {
        "id": "1065",
        "type": "answers",
        "attributes": {
          "text": "35 months",
          "active": true,
          "position": 2
        }
      },
      {
        "id": "1066",
        "type": "answers",
        "attributes": {
          "text": "11 months",
          "active": true,
          "position": 3
        }
      },
      {
        "id": "1067",
        "type": "answers",
        "attributes": {
          "text": "$3,000",
          "active": true,
          "position": 1
        }
      },
      {
        "id": "1068",
        "type": "answers",
        "attributes": {
          "text": "$3,743",
          "active": true,
          "position": 2
        }
      },
      {
        "id": "1069",
        "type": "answers",
        "attributes": {
          "text": "$6,743 ",
          "active": true,
          "position": 3
        }
      }
    ]
  }
  
  })();
});

require.register("local-data/polls/scenarios-using-business-cards.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "68",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-using-business-cards",
        "name": "Using Business cards: Scenarios Poll",
        "description": "Using Business card: Scenarios",
        "title": "Using Business card: Scenarios",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "68",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Using Business card: Scenarios",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "272",
              "type": "response_set_questions"
            }

          ]
        }
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "Do you use your Business Debit or Credit Card to purchase more creamer at a local supermarket?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1070",
              "type": "answers"
            },
            {
              "id": "1071",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "272",
      "type": "response_set_questions",
      "attributes": {
        "text": "Do you use your Business Debit or Credit Card?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1070",
              "type": "answers"
            },
            {
              "id": "1071",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1070",
      "type": "answers",
      "attributes": {
        "text": "Debit Card",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1071",
      "type": "answers",
      "attributes": {
        "text": "Credit Card",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/leading-sources-of-debt.json", function(exports, require, module) {
  module.exports = (function() {
return {
    "data": {
        "id": "leading-sources-of-debt_poll",
        "type": "response_sets",
        "attributes": {
            "time_taken": null,
            "fields": {},
            "answers": [
                {
                    "question_id": "EX_POLL_QUES_1",
                    "value": "EX_POLL_ANS_1",
                    "response_type": "single_selection"
                }
            ],
            "current_section_id": 68,
            "grade": null,
            "status": "started",
            "web_hooks": {},
            "evaluation_has_started": false
        },
        "relationships": {
            "evaluation": {
                "data": {
                    "id": "68",
                    "type": "evaluations"
                }
            },
            "sections": {
                "data": [
                    {
                        "id": "68",
                        "type": "response_set_sections"
                    }
                ]
            }
        }
    },
    "included": [
        {
            "id": "68",
            "type": "evaluations",
            "attributes": {
                "slug": "leading-sources-of-debt",
                "name": "Leading Source of Debt",
                "description": "",
                "title": "What is the leading source of debt in America?",
                "active": true,
                "intro_text": null,
                "passed_text": null,
                "failure_text": null,
                "start_date": "2017-09-01",
                "end_date": "2018-09-01",
                "passing_grade": 0,
                "show_results_screen": false,
                "shuffle": false,
                "hide_grade": false,
                "show_intro": true
            },
            "relationships": {
                "sections": {
                    "data": [
                        {
                            "id": "68",
                            "type": "sections"
                        }
                    ]
                }
            }
        },
        {
            "id": "68",
            "type": "response_set_sections",
            "attributes": {
                "title": "What is the leading source of debt in America?",
                "active": true,
                "shuffle": false,
                "bank": false,
                "bank_count": null,
                "position": 1,
                "completed": false
            },
            "relationships": {
                "questions": {
                    "data": [
                        {
                            "id": "EX_POLL_QUES_1",
                            "type": "response_set_questions"
                        }
                    ]
                }
            }
        },
        {
            "id": "EX_POLL_QUES_1",
            "type": "response_set_questions",
            "attributes": {
                "text": "What is the leading source of debt in America?",
                "active": true,
                "shuffle": false,
                "position": 1,
                "responded": true
            },
            "relationships": {
                "answers": {
                    "data": [
                        {
                            "id": "EX_POLL_ANS_1",
                            "type": "answers"
                        },
                        {
                            "id": "EX_POLL_ANS_2",
                            "type": "answers"
                        },
                        {
                            "id": "EX_POLL_ANS_3",
                            "type": "answers"
                        },
                        {
                            "id": "EX_POLL_ANS_4",
                            "type": "answers"
                        }
                    ]
                }
            }
        },
        {
            "id": "EX_POLL_ANS_1",
            "type": "answers",
            "attributes": {
                "text": "Mortgage debt",
                "active": true,
                "position": 1
            }
        },
        {
            "id": "EX_POLL_ANS_2",
            "type": "answers",
            "attributes": {
                "text": "Student loan debt",
                "active": true,
                "position": 2
            }
        },
        {
            "id": "EX_POLL_ANS_3",
            "type": "answers",
            "attributes": {
                "text": "Credit card debt",
                "active": true,
                "position": 3
            }
        },
        {
            "id": "EX_POLL_ANS_4",
            "type": "answers",
            "attributes": {
                "text": "Car loan debt",
                "active": true,
                "position": 4
            }
        }
    ]
}

  })();
});

require.register("local-data/polls/scenarios-business-cards.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "13696615-9bc6-4fb3-b507-ed81c634a3b6",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [],
      "current_section_id": 67,
      "grade": null,
      "status": "created",
      "web_hooks": {
        "completed": "http://content-service.dev:5001/api/v1/response_sets/72a62515-9f09-490c-b974-0b3a0ac8bffc/complete"
      },
      "evaluation_has_started": true
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "67",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "67",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "67",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-business-cards",
        "name": "Business Cards: Scenarios Poll",
        "description": "Business Cards: Scenarios",
        "title": "Business Cards: Scenarios",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "67",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "67",
      "type": "response_set_sections",
      "attributes": {
        "title": "Business Cards: Scenarios",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "267",
              "type": "response_set_questions"
            },
            {
              "id": "268",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "267",
      "type": "response_set_questions",
      "attributes": {
        "text": "What credit type do you need?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1058",
              "type": "answers"
            },
            {
              "id": "1059",
              "type": "answers"
            },
            {
              "id": "1060",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1058",
      "type": "answers",
      "attributes": {
        "text": "Lines of Credit",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1059",
      "type": "answers",
      "attributes": {
        "text": "Personal Credit Card",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1060",
      "type": "answers",
      "attributes": {
        "text": "Business Credit Card",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "268",
      "type": "response_set_questions",
      "attributes": {
        "text": "How would you make the purchase?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1061",
              "type": "answers"
            },
            {
              "id": "1062",
              "type": "answers"
            },
            {
              "id": "1063",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1061",
      "type": "answers",
      "attributes": {
        "text": "Lines of Credit",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1062",
      "type": "answers",
      "attributes": {
        "text": "Term Loans",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1063",
      "type": "answers",
      "attributes": {
        "text": "Business Credit Card",
        "active": true,
        "position": 3
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/joes-shop-profit-and-loss.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 74,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "74",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "74",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "74",
      "type": "evaluations",
      "attributes": {
        "slug": "joes-shop-profit-and-loss",
        "name": "Profit & Loss: Joe’s T-shirt Print Shop Poll",
        "description": "Profit & Loss: Scenarios",
        "title": "Profit & Loss: Joe’s T-shirt Print Shop",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "74",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "74",
      "type": "response_set_sections",
      "attributes": {
        "title": "Profit & Loss: Scenarios",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "270",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "Has Joe’s T-Shirt Print Shop earned more revenue than what they spent on production costs?" ,
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1034",
              "type": "answers"
            },
            {
              "id": "1035",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "270",
      "type": "response_set_questions",
      "attributes": {
        "text": "Is Joe’s T-Shirt Print Shop profitable?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1034",
              "type": "answers"
            },
            {
              "id": "1035",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1034",
      "type": "answers",
      "attributes": {
        "text": "YES",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1035",
      "type": "answers",
      "attributes": {
        "text": "NO",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-id-theft.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [],
      "current_section_id": 71,
      "grade": null,
      "status": "created",
      "web_hooks": {
        "completed": "http://content-service.dev:5001/api/v1/response_sets/ad5000d0-5649-4e14-8c11-33f879a885fb/complete"
      },
      "evaluation_has_started": true
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "71",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "71",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "71",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-id-theft",
        "name": "Your Wallet: Scenarios Poll",
        "description": "Your Wallet: Scenarios",
        "title": "Your Wallet: Scenarios",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "71",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "71",
      "type": "response_set_sections",
      "attributes": {
        "title": "Your Wallet: Scenarios",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "276",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "276",
      "type": "response_set_questions",
      "attributes": {
        "text": "Which of the following do you carry with you everyday?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [

          ]
        }
      }
    }
  ]
}


  })();
});

require.register("local-data/polls/scenarios-joel-account.json", function(exports, require, module) {
  module.exports = (function() {
return {
    "data": {
      "id": "27235e41-02cc-4d43-8e02-3e29406a4923",
      "type": "response_sets",
      "attributes": {
        "time_taken": null,
        "fields": {},
        "answers": [
          {
            "question_id": 269,
            "value": 1065,
            "response_type": "single_selection"
          }
        ],
        "current_section_id": 68,
        "grade": null,
        "status": "started",
        "web_hooks": {},
        "evaluation_has_started": false
      },
      "relationships": {
        "evaluation": {
          "data": {
            "id": "68",
            "type": "evaluations"
          }
        },
        "sections": {
          "data": [
            {
              "id": "68",
              "type": "response_set_sections"
            }
          ]
        }
      }
    },
    "included": [
      {
        "id": "68",
        "type": "evaluations",
        "attributes": {
          "slug": "scenarios-joel-account",
          "name": "Joel's Account",
          "description": "Joel's Account",
          "title": "Joel's Account",
          "active": true,
          "intro_text": null,
          "passed_text": null,
          "failure_text": null,
          "start_date": "2017-09-01",
          "end_date": "2018-09-01",
          "passing_grade": 0,
          "show_results_screen": false,
          "shuffle": false,
          "hide_grade": false,
          "show_intro": true
        },
        "relationships": {
          "sections": {
            "data": [
              {
                "id": "68",
                "type": "sections"
              }
            ]
          }
        }
      },
      {
        "id": "68",
        "type": "response_set_sections",
        "attributes": {
          "title": "Joel's Account",
          "active": true,
          "shuffle": false,
          "bank": false,
          "bank_count": null,
          "position": 1,
          "completed": false
        },
        "relationships": {
          "questions": {
            "data": [
              {
                "id": "269",
                "type": "response_set_questions"
              },
              {
                "id": "271",
                "type": "response_set_questions"
              },
              {
                "id": "272",
                "type": "response_set_questions"
              },
                {
              "id": "273",
              "type": "response_set_questions"
                }
  
            ]
          }
        }
      },
      {
        "id": "269",
        "type": "response_set_questions",
        "attributes": {
          "text": "Why was Joel’s account overdrawn?",
          "active": true,
          "shuffle": false,
          "position": 1,
          "responded": true
        },
        "relationships": {
          "answers": {
            "data": [
              {
                "id": "1064",
                "type": "answers"
              },
              {
                "id": "1065",
                "type": "answers"
              },
              {
                "id": "1066",
                "type": "answers"
              }
            ]
          }
        }
      },
      {
        "id": "1064",
        "type": "answers",
        "attributes": {
          "text": "There was a mistake with his bank.",
          "active": true,
          "position": 1
        }
      },
      {
        "id": "1065",
        "type": "answers",
        "attributes": {
          "text": "Joel did not wait long enough for the funds to be available after depositing his check.",
          "active": true,
          "position": 2
        }
      },
      {
        "id": "1066",
        "type": "answers",
        "attributes": {
          "text": "You cannot use mobile banking to deposit checks. ",
          "active": true,
          "position": 3
        }
      },
      {
        "id": "271",
        "type": "response_set_questions",
        "attributes": {
          "text": "Money deposited through mobile banking is always available immediately.",
          "active": true,
          "shuffle": false,
          "position": 2,
          "responded": false
        },
        "relationships": {
          "answers": {
            "data": [
              {
                "id": "1070",
                "type": "answers"
              },
              {
                "id": "1071",
                "type": "answers"
              }
            ]
          }
        }
      },
      {
        "id": "272",
        "type": "response_set_questions",
        "attributes": {
          "text": "Your financial institution may have a limit on how large a check you can deposit through mobile banking.",
          "active": true,
          "shuffle": false,
          "position": 2,
          "responded": false
        },
        "relationships": {
          "answers": {
            "data": [
              {
                "id": "1070",
                "type": "answers"
              },
              {
                "id": "1071",
                "type": "answers"
              }
            ]
          }
        }
      },
      {
        "id": "273",
        "type": "response_set_questions",
        "attributes": {
          "text": "Your financial institution may deposit some of the money from a mobile banking deposit immediately, but the rest may not be available until later.",
          "active": true,
          "shuffle": false,
          "position": 2,
          "responded": false
        },
        "relationships": {
          "answers": {
            "data": [
              {
                "id": "1070",
                "type": "answers"
              },
              {
                "id": "1071",
                "type": "answers"
              }
            ]
          }
        }
      },
      {
        "id": "1070",
        "type": "answers",
        "attributes": {
          "text": "True",
          "active": true,
          "position": 1
        }
      },
      {
        "id": "1071",
        "type": "answers",
        "attributes": {
          "text": "False",
          "active": true,
          "position": 2
        }
      }
    ]
  }
  
  })();
});

require.register("local-data/polls/scenarios-real-estate-loans.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "9f967c25-9261-443a-a4dd-ca1de568a8e0",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 272,
          "value": 1073,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 69,
      "grade": null,
      "status": "started",
      "web_hooks": {
        "completed": "http://content-service.dev:5001/api/v1/response_sets/d5d4dbc8-46e7-4bf8-b513-91f07a2567d6/complete"
      },
      "evaluation_has_started": true
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "69",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "69",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "69",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-real-estate-loans",
        "name": "Real Estate Loans: Scenarios Poll",
        "description": "Real Estate Loans: Scenarios",
        "title": "Real Estate Loans: Scenarios",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "69",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "69",
      "type": "response_set_sections",
      "attributes": {
        "title": "Real Estate Loans: Scenarios",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "272",
              "type": "response_set_questions"
            },
            {
              "id": "273",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "272",
      "type": "response_set_questions",
      "attributes": {
        "text": "Which credit type do you need?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1073",
              "type": "answers"
            },
            {
              "id": "1074",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1073",
      "type": "answers",
      "attributes": {
        "text": "Owner occupied",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1074",
      "type": "answers",
      "attributes": {
        "text": "Non-owner occupied",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "273",
      "type": "response_set_questions",
      "attributes": {
        "text": "Which credit type do you need?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1075",
              "type": "answers"
            },
            {
              "id": "1076",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1075",
      "type": "answers",
      "attributes": {
        "text": "Owner occupied",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1076",
      "type": "answers",
      "attributes": {
        "text": "Non-owner occupied",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/business-banking-needs.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "business-banking-needs",
        "name": "Business Banking Needs",
        "description": "Business Banking Needs",
        "title": "Business Banking Needs",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Business Banking Needs",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "My business banking needs include&hellip;",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            },
            {
              "id": "1067",
              "type": "answers"
            },
            {
              "id": "1068",
              "type": "answers"
            },
            {
              "id": "1069",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "Accepting payment from customers",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "Making payments to vendors",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "Making deposits",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1067",
      "type": "answers",
      "attributes": {
        "text": "Getting cash and change",
        "active": true,
        "position": 4
      }
    },
    {
      "id": "1068",
      "type": "answers",
      "attributes": {
        "text": "Paying employees and service providers",
        "active": true,
        "position": 5
      }
    },
    {
      "id": "1069",
      "type": "answers",
      "attributes": {
        "text": "Securing loans",
        "active": true,
        "position": 6
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-joe-shop-enough-capital.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4924",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 79,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "79",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "79",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "79",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-joe-shop-enough-capital",
        "name": "Balance Sheet: Joe’s Shop",
        "description": "Balance Sheet: Joe’s Shop",
        "title": "Balance Sheet: Joe’s Shop",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "79",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "79",
      "type": "response_set_sections",
      "attributes": {
        "title": "Balance Sheet: Joe’s Shop",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "300",
              "type": "response_set_questions"
            },
            {
              "id": "301",
              "type": "response_set_questions"
            },
            {
              "id": "302",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "300",
      "type": "response_set_questions",
      "attributes": {
        "text": "",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1200",
              "type": "answers"
            },
            {
              "id": "1201",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1200",
      "type": "answers",
      "attributes": {
        "text": "YES",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1201",
      "type": "answers",
      "attributes": {
        "text": "NO",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-joe-shop-positive-equity-position.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 79,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "79",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "79",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "79",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-joe-shop-enough-capital",
        "name": "Balance Sheet: Joe’s Shop",
        "description": "Balance Sheet: Joe’s Shop",
        "title": "Balance Sheet: Joe’s Shop",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "79",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "79",
      "type": "response_set_sections",
      "attributes": {
        "title": "Balance Sheet: Joe’s Shop",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "300",
              "type": "response_set_questions"
            },
            {
              "id": "301",
              "type": "response_set_questions"
            },
            {
              "id": "302",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "300",
      "type": "response_set_questions",
      "attributes": {
        "text": "What is Joe's T-Shirt Shop working capital position?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1200",
              "type": "answers"
            },
            {
              "id": "1201",
              "type": "answers"
            },
            {
              "id": "1202",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1200",
      "type": "answers",
      "attributes": {
        "text": "Negative",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1201",
      "type": "answers",
      "attributes": {
        "text": "Positive/Acceptable",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1202",
      "type": "answers",
      "attributes": {
        "text": "Strong",
        "active": true,
        "position": 3
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/protecting-money.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "protecting-money",
        "name": "Ali's Decision: Part 1",
        "description": "Ali's Decision: Part 1",
        "title": "Ali's Decision: Part 1",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Ali's Decision: Part 1",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "What other options would work for Ali so that his money is protected?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            },
            {
              "id": "1067",
              "type": "answers"
            },
            {
              "id": "1068",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "A checking account.",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "A traditional savings account.",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "A certificate of deposit (CD)",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1067",
      "type": "answers",
      "attributes": {
        "text": "A money market account (MMA)",
        "active": true,
        "position": 4
      }
    },
    {
      "id": "1068",
      "type": "answers",
      "attributes": {
        "text": "A special account for a minor",
        "active": true,
        "position": 5
      }
    }
  ]
}
  })();
});

require.register("local-data/polls/wesb-q1.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "protecting-money",
        "name": "Ali's Decision: Part 1",
        "description": "Ali's Decision: Part 1",
        "title": "Ali's Decision: Part 1",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Ali's Decision: Part 1",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "What other options would work for Ali so that his money is protected?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            },
            {
              "id": "1067",
              "type": "answers"
            },
            {
              "id": "1068",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "A checking account.",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "A traditional savings account.",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "A certificate of deposit (CD)",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1067",
      "type": "answers",
      "attributes": {
        "text": "A money market account (MMA)",
        "active": true,
        "position": 4
      }
    },
    {
      "id": "1068",
      "type": "answers",
      "attributes": {
        "text": "A special account for a minor",
        "active": true,
        "position": 5
      }
    }
  ]
}
  })();
});

require.register("local-data/polls/scenarios-cost-joint.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [],
      "current_section_id": 71,
      "grade": null,
      "status": "created",
      "web_hooks": {
        "completed": "http://content-service.dev:5001/api/v1/response_sets/ad5000d0-5649-4e14-8c11-33f879a885fb/complete"
      },
      "evaluation_has_started": true
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "71",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "71",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "71",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-cost-joint",
        "name": "The Cost of Merging Credit",
        "description": "The Cost of Merging Credit",
        "title": "The Cost of Merging Credit",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "71",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "71",
      "type": "response_set_sections",
      "attributes": {
        "title": "The Cost of Merging Credit",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "276",
              "type": "response_set_questions"
            },
            {
              "id": "277",
              "type": "response_set_questions"
            },
            {
              "id": "278",
              "type": "response_set_questions"
            },
            {
              "id": "279",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "276",
      "type": "response_set_questions",
      "attributes": {
        "text": "Will having a joint credit card or checking account affect Tameka’s credit score?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1083",
              "type": "answers"
            },
            {
              "id": "1084",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1083",
      "type": "answers",
      "attributes": {
        "text": "YES",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1084",
      "type": "answers",
      "attributes": {
        "text": "NO",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "277",
      "type": "response_set_questions",
      "attributes": {
        "text": "Will having a joint credit card or checking account affect Tameka’s credit score?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1089",
              "type": "answers"
            },
            {
              "id": "1090",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1089",
      "type": "answers",
      "attributes": {
        "text": "POSITIVELY",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1090",
      "type": "answers",
      "attributes": {
        "text": "NEGATIVELY",
        "active": true,
        "position": 2
      }
    }
  ]
}
  })();
});

require.register("local-data/polls/financial-emergency.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "68",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "financial-emergency",
        "name": "Financial Emergency",
        "title": "Financial Emergency",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2020-12-01",
        "end_date": "2021-12-31",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "68",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Financial Emergency",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "270",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "272",
              "type": "response_set_questions"
            },
            {
              "id": "273",
              "type": "response_set_questions"
            },
            {
              "id": "274",
              "type": "response_set_questions"
            },
            {
              "id": "275",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "You blow a tire and need to buy a new one.",
        "active": true,
        "shuffle": false,
        "position": 0,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "270",
      "type": "response_set_questions",
      "attributes": {
        "text": "You slipped on your deck and need to go to the ER.",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },      
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "Your video game console breaks  suddenly.",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "272",
      "type": "response_set_questions",
      "attributes": {
        "text": "Your furnace breaks in January.",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "273",
      "type": "response_set_questions",
      "attributes": {
        "text": "Your laptop breaks. You are a freelancer and need your laptop for work.",
        "active": true,
        "shuffle": false,
        "position": 4,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },      
    {
      "id": "274",
      "type": "response_set_questions",
      "attributes": {
        "text": "Your laptop breaks. You do not need your laptop for your job, but you enjoy watching movies on it.",
        "active": true,
        "shuffle": false,
        "position": 5,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },            
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "Yes",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "No",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-stay-on-track.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "protecting-money",
        "name": "Ali's Decision: Part 1",
        "description": "Ali's Decision: Part 1",
        "title": "Ali's Decision: Part 1",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Ali's Decision: Part 1",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "Which of the following statements have you said to yourself?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            },
            {
              "id": "1067",
              "type": "answers"
            },
            {
              "id": "1068",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "I'll wake up early to exercise tomorrow",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "I'll start saving when I get a raise",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "I'll go to bed early tomorrow",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1067",
      "type": "answers",
      "attributes": {
        "text": "I'll stop watching after this one last episode",
        "active": true,
        "position": 4
      }
    },
    {
      "id": "1068",
      "type": "answers",
      "attributes": {
        "text": "I'll borrow less on my credit card next month",
        "active": true,
        "position": 5
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-joe-shop-cash-needs.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 79,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "79",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "79",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "79",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-joe-shop-cash-needs",
        "name": "Cash Flow: Joe’s Shop",
        "description": "Cash Flow: Joe’s Shop",
        "title": "Cash Flow: Joe’s Shop",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "79",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "79",
      "type": "response_set_sections",
      "attributes": {
        "title": "Cash Flow: Joe’s Shop",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "300",
              "type": "response_set_questions"
            },
            {
              "id": "301",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "300",
      "type": "response_set_questions",
      "attributes": {
        "text": "",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1200",
              "type": "answers"
            },
            {
              "id": "1201",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "301",
      "type": "response_set_questions",
      "attributes": {
        "text": "",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1200",
              "type": "answers"
            },
            {
              "id": "1201",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1200",
      "type": "answers",
      "attributes": {
        "text": "YES",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1201",
      "type": "answers",
      "attributes": {
        "text": "NO",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-sew-rights.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "68",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-sew-rights",
        "name": "Sew Right: Scenarios Poll",
        "description": "Sew Right: Scenarios",
        "title": "Sew Right: Scenarios",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "68",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Sew Right: Scenarios",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            }

          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "Which of the followig 'Cs' would a lender consider when thinking about Jovena's asset ownership?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            },

            {
              "id": "1067",
              "type": "answers"
            },
            {
              "id": "1068",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "Character",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "Capacity",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "Capital",
        "active": true,
        "position": 3
      }
    },
        {
      "id": "1067",
      "type": "answers",
      "attributes": {
        "text": "Collateral",
        "active": true,
        "position": 4
      }
    },
    {
      "id": "1068",
      "type": "answers",
      "attributes": {
        "text": "Conditions",
        "active": true,
        "position": 5
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "Which of the following 'Cs' would a lender consider when thinking about Jovena's credit card history?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1070",
              "type": "answers"
            },
            {
              "id": "1071",
              "type": "answers"
            },
            {
              "id": "1072",
              "type": "answers"
            },

            {
              "id": "1073",
              "type": "answers"
            },
            {
              "id": "1074",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1070",
      "type": "answers",
      "attributes": {
        "text": "Character",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1071",
      "type": "answers",
      "attributes": {
        "text": "Capacity",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1072",
      "type": "answers",
      "attributes": {
        "text": "Capital",
        "active": true,
        "position": 3
      }
    },

    {
      "id": "1073",
      "type": "answers",
      "attributes": {
        "text": "Collateral",
        "active": true,
        "position": 3
      }
    },

    {
      "id": "1074",
      "type": "answers",
      "attributes": {
        "text": "Conditions",
        "active": true,
        "position": 3
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-types-of-accounts.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "68",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-alis-decision",
        "name": "Common Account Types",
        "description": "Common Account Types",
        "title": "Common Account Types",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "68",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Sew Right: Scenarios",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "272",
              "type": "response_set_questions"
            },
            {
              "id": "273",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "What’s the best type of account for Jovena?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "Payroll Account",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "Small Business Checking Account",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "Certificates of Deposit ",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "What’s the best type of account for Joe?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1070",
              "type": "answers"
            },
            {
              "id": "1071",
              "type": "answers"
            },
            {
              "id": "1072",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1070",
      "type": "answers",
      "attributes": {
        "text": "Payroll Account",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1071",
      "type": "answers",
      "attributes": {
        "text": "Small Business Checking Account",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1072",
      "type": "answers",
      "attributes": {
        "text": "Commercial Checking Account",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1073",
      "type": "answers",
      "attributes": {
        "text": "Savings Account",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "272",
      "type": "response_set_questions",
      "attributes": {
        "text": "What’s the best type of account for the Carter brothers?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1073",
              "type": "answers"
            },
            {
              "id": "1071",
              "type": "answers"
            },
            {
              "id": "1072",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1070",
      "type": "answers",
      "attributes": {
        "text": "Option A",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1071",
      "type": "answers",
      "attributes": {
        "text": "Option B",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "273",
      "type": "response_set_questions",
      "attributes": {
        "text": "Which option would give the borrower, Ali, more time to pay off the loan?",
        "active": true,
        "shuffle": false,
        "position": 4,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1070",
              "type": "answers"
            },
            {
              "id": "1071",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1070",
      "type": "answers",
      "attributes": {
        "text": "Option A",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1071",
      "type": "answers",
      "attributes": {
        "text": "Option B",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/cr-and-reports-surveys.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001110",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [],
      "current_section_id": 71,
      "grade": null,
      "status": "created",
      "web_hooks": {
        "completed": "http://content-service.dev:5001/api/v1/response_sets/ad5000d0-5649-4e14-8c11-33f879a885fb/complete"
      },
      "evaluation_has_started": true
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "71",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "71",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "71",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-term-loan",
        "name": "Surveys",
        "description": "Surveys",
        "title": "Surveys",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "71",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "71",
      "type": "response_set_sections",
      "attributes": {
        "title": "Term Loan: Scenarios",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "276",
              "type": "response_set_questions"
            },
            {
              "id": "278",
              "type": "response_set_questions"
            },
            {
              "id": "277",
              "type": "response_set_questions"
            },
            {
              "id": "279",
              "type": "response_set_questions"
            },
            {
              "id": "280",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "276",
      "type": "response_set_questions",
      "attributes": {
        "text": "I know what my credit score is.",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1083",
              "type": "answers"
            },
            {
              "id": "1084",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1083",
      "type": "answers",
      "attributes": {
        "text": "Yes",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1084",
      "type": "answers",
      "attributes": {
        "text": "No",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "278",
      "type": "response_set_questions",
      "attributes": {
        "text": "I always pay every bill on time every month.",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1089",
              "type": "answers"
            },
            {
              "id": "1090",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1089",
      "type": "answers",
      "attributes": {
        "text": "Yes",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1090",
      "type": "answers",
      "attributes": {
        "text": "No",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "277",
      "type": "response_set_questions",
      "attributes": {
        "text": "My credit is not ‘maxed out;’the amount I owe is less than 30% of my available credit.",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1086",
              "type": "answers"
            },
            {
              "id": "1087",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1086",
      "type": "answers",
      "attributes": {
        "text": "Yes",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1087",
      "type": "answers",
      "attributes": {
        "text": "No",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "279",
      "type": "response_set_questions",
      "attributes": {
        "text": "I request a new credit report each year. ",
        "active": true,
        "shuffle": false,
        "position": 4,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1094",
              "type": "answers"
            },
            {
              "id": "1095",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1094",
      "type": "answers",
      "attributes": {
        "text": "Yes",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1095",
      "type": "answers",
      "attributes": {
        "text": "No",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "280",
      "type": "response_set_questions",
      "attributes": {
        "text": "I review my credit report each year to check and fix any errors.",
        "active": true,
        "shuffle": false,
        "position": 5,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1096",
              "type": "answers"
            },
            {
              "id": "1097",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1096",
      "type": "answers",
      "attributes": {
        "text": "Yes",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1097",
      "type": "answers",
      "attributes": {
        "text": "No",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-tale-of-two-friends.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [],
      "current_section_id": 71,
      "grade": null,
      "status": "created",
      "web_hooks": {
        "completed": "http://content-service.dev:5001/api/v1/response_sets/ad5000d0-5649-4e14-8c11-33f879a885fb/complete"
      },
      "evaluation_has_started": true
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "71",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "71",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "71",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-tale-of-two-friends",
        "name": "Tale of Two Friends",
        "description": "Tale of Two Friends",
        "title": "Tale of Two Friends",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "71",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "71",
      "type": "response_set_sections",
      "attributes": {
        "title": "Tale of Two Friends",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "276",
              "type": "response_set_questions"
            },
            {
              "id": "277",
              "type": "response_set_questions"
            },
            {
              "id": "278",
              "type": "response_set_questions"
            },
            {
              "id": "279",
              "type": "response_set_questions"
            },
            {
              "id": "280",
              "type": "response_set_questions"
            },
            {
              "id": "281",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "276",
      "type": "response_set_questions",
      "attributes": {
        "text": "Who had more trouble getting a loan?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1083",
              "type": "answers"
            },
            {
              "id": "1084",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1083",
      "type": "answers",
      "attributes": {
        "text": "ANNA",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1084",
      "type": "answers",
      "attributes": {
        "text": "BELLA",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "277",
      "type": "response_set_questions",
      "attributes": {
        "text": "Who had more trouble getting a loan?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1089",
              "type": "answers"
            },
            {
              "id": "1090",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1089",
      "type": "answers",
      "attributes": {
        "text": "ANNA",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1090",
      "type": "answers",
      "attributes": {
        "text": "BELLA",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "278",
      "type": "response_set_questions",
      "attributes": {
        "text": "Who had a higher interest rate?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1086",
              "type": "answers"
            },
            {
              "id": "1087",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1086",
      "type": "answers",
      "attributes": {
        "text": "ANNA",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1087",
      "type": "answers",
      "attributes": {
        "text": "BELLA",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "279",
      "type": "response_set_questions",
      "attributes": {
        "text": "Whose insurance rates were higher?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1086",
              "type": "answers"
            },
            {
              "id": "1087",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1086",
      "type": "answers",
      "attributes": {
        "text": "ANNA",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1087",
      "type": "answers",
      "attributes": {
        "text": "BELLA",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "280",
      "type": "response_set_questions",
      "attributes": {
        "text": "Whose home fell into foreclosure?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1086",
              "type": "answers"
            },
            {
              "id": "1087",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1086",
      "type": "answers",
      "attributes": {
        "text": "ANNA",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1087",
      "type": "answers",
      "attributes": {
        "text": "BELLA",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "281",
      "type": "response_set_questions",
      "attributes": {
        "text": "Whose home fell into foreclosure?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1086",
              "type": "answers"
            },
            {
              "id": "1087",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1086",
      "type": "answers",
      "attributes": {
        "text": "ANNA",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1087",
      "type": "answers",
      "attributes": {
        "text": "BELLA",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/how-much-did-you-learn.json", function(exports, require, module) {
  module.exports = (function() {
return {
    "data": {
      "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
      "type": "response_sets",
      "attributes": {
        "time_taken": null,
        "fields": {},
        "answers": [{
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }],
        "current_section_id": 68,
        "grade": null,
        "status": "started",
        "web_hooks": {},
        "evaluation_has_started": false
      },
      "relationships": {
        "evaluation": {
          "data": {
            "id": "68",
            "type": "evaluations"
          }
        },
        "sections": {
          "data": [{
            "id": "68",
            "type": "response_set_sections"
          }]
        }
      }
    },
    "included": [{
        "id": "68",
        "type": "evaluations",
        "attributes": {
          "slug": "how-much-did-you-learn",
          "name": "How Much Did You Learn",
          "description": "How Much Did You Learn?",
          "title": "How Much Did You Learn?",
          "active": true,
          "intro_text": null,
          "passed_text": null,
          "failure_text": null,
          "start_date": "2017-09-01",
          "end_date": "2018-09-01",
          "passing_grade": 0,
          "show_results_screen": false,
          "shuffle": false,
          "hide_grade": false,
          "show_intro": true
        },
        "relationships": {
          "sections": {
            "data": [{
              "id": "68",
              "type": "sections"
            }]
          }
        }
      },
      {
        "id": "68",
        "type": "response_set_sections",
        "attributes": {
          "title": "How Mucch Did You Learn",
          "active": true,
          "shuffle": false,
          "bank": false,
          "bank_count": null,
          "position": 1,
          "completed": false
        },
        "relationships": {
          "questions": {
            "data": [{
                "id": "269",
                "type": "response_set_questions"
              }
            ]
          }
        }
      },
      {
        "id": "269",
        "type": "response_set_questions",
        "attributes": {
          "text": "Do you feel you learned more about mobile banking after taking this course?",
          "active": true,
          "shuffle": false,
          "position": 1,
          "responded": true
        },
        "relationships": {
          "answers": {
            "data": [{
                "id": "1064",
                "type": "answers"
              },
              {
                "id": "1065",
                "type": "answers"
              }
            ]
          }
        }
      },
      {
        "id": "1064",
        "type": "answers",
        "attributes": {
          "text": "Yes",
          "active": true,
          "position": 1
        }
      },
      {
        "id": "1065",
        "type": "answers",
        "attributes": {
          "text": "No",
          "active": true,
          "position": 2
        }
      },
      {
        "id": "1066",
        "type": "answers",
        "attributes": {
          "text": "Making deposits",
          "active": true,
          "position": 3
        }
      }
    ]
  }
  
  })();
});

require.register("local-data/polls/scenarios-build-budget.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001113",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [],
      "current_section_id": 71,
      "grade": null,
      "status": "created",
      "web_hooks": {
        "completed": "http://content-service.dev:5001/api/v1/response_sets/ad5000d0-5649-4e14-8c11-33f879a885fb/complete"
      },
      "evaluation_has_started": true
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "71",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "71",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "71",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-build-budget",
        "name": "How to Build a Budget ",
        "description": "How to Build a Budget ",
        "title": "How to Build a Budget",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "71",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "71",
      "type": "response_set_sections",
      "attributes": {
        "title": "The Cost of Merging Credit",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "276",
              "type": "response_set_questions"
            },
            {
              "id": "277",
              "type": "response_set_questions"
            },
            {
              "id": "278",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "276",
      "type": "response_set_questions",
      "attributes": {
        "text": "Marta spends 76% of her income on her needs. Per the rule of thumb, is she spending too much?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1083",
              "type": "answers"
            },
            {
              "id": "1084",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1083",
      "type": "answers",
      "attributes": {
        "text": "YES",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1084",
      "type": "answers",
      "attributes": {
        "text": "NO",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "277",
      "type": "response_set_questions",
      "attributes": {
        "text": "Marta spends 16% of her income on her wants. According to the rule of thumb, is she spending too much?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1089",
              "type": "answers"
            },
            {
              "id": "1090",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1089",
      "type": "answers",
      "attributes": {
        "text": "YES",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1090",
      "type": "answers",
      "attributes": {
        "text": "NO",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "278",
      "type": "response_set_questions",
      "attributes": {
        "text": "14% of Marta’s income is disposable. According to the rule of thumb, does she have enough to save or pay back her debts?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1091",
              "type": "answers"
            },
            {
              "id": "1092",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1091",
      "type": "answers",
      "attributes": {
        "text": "YES",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1092",
      "type": "answers",
      "attributes": {
        "text": "NO",
        "active": true,
        "position": 2
      }
    }
  ]
}
  })();
});

require.register("local-data/polls/types-of-accounts.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "types-of-accounts",
        "name": "Types of Accounts",
        "description": "How familiar are you with…",
        "title": "Types of Accounts",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Scenario Identity theft",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "272",
              "type": "response_set_questions"
            },
            {
              "id": "273",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "Checking accounts?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "Money market accounts?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
            "id": "1064",
            "type": "answers"
          },
          {
            "id": "1065",
            "type": "answers"
          },
          {
            "id": "1066",
            "type": "answers"
          }
          ]
        }
      }
    },
    {
      "id": "272",
      "type": "response_set_questions",
      "attributes": {
        "text": "Certificates of deposit?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
            "id": "1064",
            "type": "answers"
          },
          {
            "id": "1065",
            "type": "answers"
          },
          {
            "id": "1066",
            "type": "answers"
          }
          ]
        }
      }
    },
    {
      "id": "273",
      "type": "response_set_questions",
      "attributes": {
        "text": "Savings accounts?",
        "active": true,
        "shuffle": false,
        "position": 4,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
            "id": "1064",
            "type": "answers"
          },
          {
            "id": "1065",
            "type": "answers"
          },
          {
            "id": "1066",
            "type": "answers"
          }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "Very",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "Somewhat",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "Not at all",
        "active": true,
        "position": 3
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-list-expenses-needs.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [],
      "current_section_id": 71,
      "grade": null,
      "status": "created",
      "web_hooks": {
        "completed": "http://content-service.dev:5001/api/v1/response_sets/ad5000d0-5649-4e14-8c11-33f879a885fb/complete"
      },
      "evaluation_has_started": true
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "71",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "71",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "71",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-list-expenses-needs",
        "name": "Marta’s Expenses",
        "description": "Marta’s Expenses",
        "title": "Marta’s Expenses",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "71",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "71",
      "type": "response_set_sections",
      "attributes": {
        "title": "Marta’s Expenses",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "276",
              "type": "response_set_questions"
            },
            {
              "id": "277",
              "type": "response_set_questions"
            },
            {
              "id": "278",
              "type": "response_set_questions"
            },
            {
              "id": "279",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "276",
      "type": "response_set_questions",
      "attributes": {
        "text": "How much disposable income does Marta have left after paying for her needs?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1083",
              "type": "answers"
            },
            {
              "id": "1084",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1083",
      "type": "answers",
      "attributes": {
        "text": "$520",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1084",
      "type": "answers",
      "attributes": {
        "text": "$480",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "277",
      "type": "response_set_questions",
      "attributes": {
        "text": "How much disposable income does Marta have left after paying for both her needs and wants?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1085",
              "type": "answers"
            },
            {
              "id": "1086",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1085",
      "type": "answers",
      "attributes": {
        "text": "$210",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1086",
      "type": "answers",
      "attributes": {
        "text": "$270",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "278",
      "type": "response_set_questions",
      "attributes": {
        "text": "How much disposable income does Marta have left after paying for her expenses and adding to her savings?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1087",
              "type": "answers"
            },
            {
              "id": "1088",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1087",
      "type": "answers",
      "attributes": {
        "text": "$210",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1088",
      "type": "answers",
      "attributes": {
        "text": "$170",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "279",
      "type": "response_set_questions",
      "attributes": {
        "text": "What are some possible uses for Marta’s $170 in disposable income?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1089",
              "type": "answers"
            },
            {
              "id": "1090",
              "type": "answers"
            },
            {
              "id": "1091",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1089",
      "type": "answers",
      "attributes": {
        "text": "PAY OFF STUDENT LOANS",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1090",
      "type": "answers",
      "attributes": {
        "text": "PAY OFF CREDIT CARD DEBT",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1091",
      "type": "answers",
      "attributes": {
        "text": "SAVE THE MONEY",
        "active": true,
        "position": 3
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-lines-of-credit.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "68",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-lines-of-credit",
        "name": "Lines of Credit: Scenarios Poll",
        "description": "Lines of Credit: Scenarios",
        "title": "Lines of Credit: Scenarios",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "68",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Lines of Credit: Scenarios",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "270",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "How would you pay your employees?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "Lines of Credit",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "Term Loans",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "Business Credit Card",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "How would you make the purchase?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1070",
              "type": "answers"
            },
            {
              "id": "1071",
              "type": "answers"
            },
            {
              "id": "1072",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1070",
      "type": "answers",
      "attributes": {
        "text": "Lines of Credit",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1071",
      "type": "answers",
      "attributes": {
        "text": "Term Loans",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1072",
      "type": "answers",
      "attributes": {
        "text": "Business Credit Card",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "270",
      "type": "response_set_questions",
      "attributes": {
        "text": "How would you make the purchase?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1067",
              "type": "answers"
            },
            {
              "id": "1068",
              "type": "answers"
            },
            {
              "id": "1069",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1067",
      "type": "answers",
      "attributes": {
        "text": "Lines of Credit",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1068",
      "type": "answers",
      "attributes": {
        "text": "Term Loans",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1069",
      "type": "answers",
      "attributes": {
        "text": "Business Credit Card",
        "active": true,
        "position": 3
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/wesb-q5.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "protecting-money",
        "name": "Ali's Decision: Part 1",
        "description": "Ali's Decision: Part 1",
        "title": "Ali's Decision: Part 1",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Ali's Decision: Part 1",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "What other options would work for Ali so that his money is protected?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            },
            {
              "id": "1067",
              "type": "answers"
            },
            {
              "id": "1068",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "A checking account.",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "A traditional savings account.",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "A certificate of deposit (CD)",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1067",
      "type": "answers",
      "attributes": {
        "text": "A money market account (MMA)",
        "active": true,
        "position": 4
      }
    },
    {
      "id": "1068",
      "type": "answers",
      "attributes": {
        "text": "A special account for a minor",
        "active": true,
        "position": 5
      }
    }
  ]
}
  })();
});

require.register("local-data/polls/maintaining-healthy-credit.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "maintaining-healthy-credit",
        "name": "Maintaining Healthy Credit",
        "description": "Maintaining Healthy Credit",
        "title": "Maintaining Healthy Credit",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Scenario Identity theft",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "272",
              "type": "response_set_questions"
            },
            {
              "id": "273",
              "type": "response_set_questions"
            },
            {
              "id": "274",
              "type": "response_set_questions"
            },
            {
              "id": "275",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "Have you ever lost a cell phone?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "Have you ever thrown away or recycled bank statements?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "272",
      "type": "response_set_questions",
      "attributes": {
        "text": "Have you ever thrown away or recycled medical bills?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "273",
      "type": "response_set_questions",
      "attributes": {
        "text": "Have you ever thrown away or recycled tax statements?",
        "active": true,
        "shuffle": false,
        "position": 4,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "274",
      "type": "response_set_questions",
      "attributes": {
        "text": "Have you ever thrown away or recycled credit card bills?",
        "active": true,
        "shuffle": false,
        "position": 5,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "275",
      "type": "response_set_questions",
      "attributes": {
        "text": "Have you ever thrown away or recycled insurance bills?",
        "active": true,
        "shuffle": false,
        "position": 6,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "276",
      "type": "response_set_questions",
      "attributes": {
        "text": "Have you ever thrown away or recycled insurance bills?",
        "active": true,
        "shuffle": false,
        "position": 7,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "Yes",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "No",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-alis-decision.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "68",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-alis-decision",
        "name": "Ali's Decision",
        "description": "Ali's Decision",
        "title": "Ali's Decision",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "68",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Sew Right: Scenarios",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "272",
              "type": "response_set_questions"
            },
            {
              "id": "273",
              "type": "response_set_questions"
            },
            {
              "id": "274",
              "type": "response_set_questions"
            },
            {
              "id": "275",
              "type": "response_set_questions"
            },
            {
              "id": "276",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "In this scenario, is Ali the lender or the borrower?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "Lender",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "Borrower",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "What factor is impacting the differences in the total amount of interest in these examples?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1070",
              "type": "answers"
            },
            {
              "id": "1071",
              "type": "answers"
            },
            {
              "id": "1072",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1070",
      "type": "answers",
      "attributes": {
        "text": "Principle amount of loan",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1071",
      "type": "answers",
      "attributes": {
        "text": "Interest rate",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1072",
      "type": "answers",
      "attributes": {
        "text": "Loan Term",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "272",
      "type": "response_set_questions",
      "attributes": {
        "text": "Which option would ultimately cost the borrower, Ali, less money in interest?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1070",
              "type": "answers"
            },
            {
              "id": "1071",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1070",
      "type": "answers",
      "attributes": {
        "text": "Option A",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1071",
      "type": "answers",
      "attributes": {
        "text": "Option B",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "273",
      "type": "response_set_questions",
      "attributes": {
        "text": "Which option would give the borrower, Ali, more time to pay off the loan?",
        "active": true,
        "shuffle": false,
        "position": 4,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1070",
              "type": "answers"
            },
            {
              "id": "1071",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1070",
      "type": "answers",
      "attributes": {
        "text": "Option A",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1071",
      "type": "answers",
      "attributes": {
        "text": "Option B",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "274",
      "type": "response_set_questions",
      "attributes": {
        "text": "Which option would give the borrower, Ali, more time to pay off the loan?",
        "active": true,
        "shuffle": false,
        "position": 5,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1070",
              "type": "answers"
            },
            {
              "id": "1071",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1070",
      "type": "answers",
      "attributes": {
        "text": "Option A",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1071",
      "type": "answers",
      "attributes": {
        "text": "Option B",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "275",
      "type": "response_set_questions",
      "attributes": {
        "text": "Which option would give the borrower, Ali, more time to pay off the loan?",
        "active": true,
        "shuffle": false,
        "position": 6,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1070",
              "type": "answers"
            },
            {
              "id": "1071",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1070",
      "type": "answers",
      "attributes": {
        "text": "Option A",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1071",
      "type": "answers",
      "attributes": {
        "text": "Option B",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-mortgage-application-process.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "68",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-mortgage-application-process",
        "name": "Pre-qualification checklist: Scenarios Poll",
        "description": "Pre-qualification checklist: Scenarios",
        "title": "Pre-qualification checklist: Scenarios",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "68",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Sew Right: Scenarios",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            }

          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            },

            {
              "id": "1067",
              "type": "answers"
            },
            {
              "id": "1068",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "800 - 850",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "740 - 799",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "670 - 739",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1067",
      "type": "answers",
      "attributes": {
        "text": "580 - 669",
        "active": true,
        "position": 4
      }
    },
    {
      "id": "1068",
      "type": "answers",
      "attributes": {
        "text": "< 579",
        "active": true,
        "position": 5
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1070",
              "type": "answers"
            },
            {
              "id": "1071",
              "type": "answers"
            },
            {
              "id": "1072",
              "type": "answers"
            },

            {
              "id": "1073",
              "type": "answers"
            },
            {
              "id": "1074",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1070",
      "type": "answers",
      "attributes": {
        "text": "800 - 850",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1071",
      "type": "answers",
      "attributes": {
        "text": "740 - 799",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1072",
      "type": "answers",
      "attributes": {
        "text": "670 - 739",
        "active": true,
        "position": 3
      }
    },

    {
      "id": "1073",
      "type": "answers",
      "attributes": {
        "text": "580 - 669",
        "active": true,
        "position": 3
      }
    },

    {
      "id": "1074",
      "type": "answers",
      "attributes": {
        "text": "< 579",
        "active": true,
        "position": 3
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-marta-budget.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "855d23d0-ef4c-4154-a24a-32099d001119",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [],
      "current_section_id": 71,
      "grade": null,
      "status": "created",
      "web_hooks": {
        "completed": "http://content-service.dev:5001/api/v1/response_sets/ad5000d0-5649-4e14-8c11-33f879a885fb/complete"
      },
      "evaluation_has_started": true
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "71",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "71",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "71",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-marta-budget.json",
        "name": "Marta’s Budget Plan",
        "description": "Marta’s Budget Plan",
        "title": "Marta’s Budget Plan",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "71",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "71",
      "type": "response_set_sections",
      "attributes": {
        "title": "Marta’s Budget Plan",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "276",
              "type": "response_set_questions"
            },
            {
              "id": "277",
              "type": "response_set_questions"
            },
            {
              "id": "278",
              "type": "response_set_questions"
            },
            {
              "id": "279",
              "type": "response_set_questions"
            },
            {
              "id": "280",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "276",
      "type": "response_set_questions",
      "attributes": {
        "text": "Which of these financial documents would Marta need for her budget?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1083",
              "type": "answers"
            },
            {
              "id": "1084",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1083",
      "type": "answers",
      "attributes": {
        "text": "W2",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1084",
      "type": "answers",
      "attributes": {
        "text": "PASSPORT",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "277",
      "type": "response_set_questions",
      "attributes": {
        "text": "Which of these financial documents would Marta need for her budget?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1089",
              "type": "answers"
            },
            {
              "id": "1090",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1089",
      "type": "answers",
      "attributes": {
        "text": "UTILITY BILL",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1090",
      "type": "answers",
      "attributes": {
        "text": "INTERNET OFFER",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "278",
      "type": "response_set_questions",
      "attributes": {
        "text": "Which of these financial documents would Marta need for her budget?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1091",
              "type": "answers"
            },
            {
              "id": "1092",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1091",
      "type": "answers",
      "attributes": {
        "text": "CREDIT REPORT",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1092",
      "type": "answers",
      "attributes": {
        "text": "DEPOSIT SLIPS",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "279",
      "type": "response_set_questions",
      "attributes": {
        "text": "Which of these financial documents would Marta need for her budget?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1093",
              "type": "answers"
            },
            {
              "id": "1094",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1093",
      "type": "answers",
      "attributes": {
        "text": "LOAN DEALS",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1094",
      "type": "answers",
      "attributes": {
        "text": "BILLS & RECEIPTS",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "280",
      "type": "response_set_questions",
      "attributes": {
        "text": "Which of these financial documents would Marta need for her budget?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1095",
              "type": "answers"
            },
            {
              "id": "1096",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1095",
      "type": "answers",
      "attributes": {
        "text": "TAX RETURNS",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1096",
      "type": "answers",
      "attributes": {
        "text": "TAX ESTIMATES",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/wesb-q6.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "protecting-money",
        "name": "Ali's Decision: Part 1",
        "description": "Ali's Decision: Part 1",
        "title": "Ali's Decision: Part 1",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Ali's Decision: Part 1",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "What other options would work for Ali so that his money is protected?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            },
            {
              "id": "1067",
              "type": "answers"
            },
            {
              "id": "1068",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "A checking account.",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "A traditional savings account.",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "A certificate of deposit (CD)",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1067",
      "type": "answers",
      "attributes": {
        "text": "A money market account (MMA)",
        "active": true,
        "position": 4
      }
    },
    {
      "id": "1068",
      "type": "answers",
      "attributes": {
        "text": "A special account for a minor",
        "active": true,
        "position": 5
      }
    }
  ]
}
  })();
});

require.register("local-data/polls/scenarios-joe-shop-positive-cash.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 79,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "79",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "79",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "79",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-joe-shop-positive-cash",
        "name": "Cash Flow: Joe’s Shop",
        "description": "Cash Flow: Joe’s Shop",
        "title": "Cash Flow: Joe’s Shop",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "79",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "79",
      "type": "response_set_sections",
      "attributes": {
        "title": "Cash Flow: Joe’s Shop",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "300",
              "type": "response_set_questions"
            },
            {
              "id": "301",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "300",
      "type": "response_set_questions",
      "attributes": {
        "text": "Is Joe's T-Shirt Shop profitable?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1200",
              "type": "answers"
            },
            {
              "id": "1201",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "301",
      "type": "response_set_questions",
      "attributes": {
        "text": "Has Joe's T-Shirt Print Shop earned more revenue than what they spent on production costs?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1200",
              "type": "answers"
            },
            {
              "id": "1201",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1200",
      "type": "answers",
      "attributes": {
        "text": "Yes",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1201",
      "type": "answers",
      "attributes": {
        "text": "No",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/financial-burden.json", function(exports, require, module) {
  module.exports = (function() {
return {
    "data": {
      "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
      "type": "response_sets",
      "attributes": {
        "time_taken": null,
        "fields": {},
        "answers": [{
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }],
        "current_section_id": 68,
        "grade": null,
        "status": "started",
        "web_hooks": {},
        "evaluation_has_started": false
      },
      "relationships": {
        "evaluation": {
          "data": {
            "id": "68",
            "type": "evaluations"
          }
        },
        "sections": {
          "data": [{
            "id": "68",
            "type": "response_set_sections"
          }]
        }
      }
    },
    "included": [{
        "id": "68",
        "type": "evaluations",
        "attributes": {
          "slug": "financial-burden",
          "name": "financial-burden",
          "description": "Emily’s Financial Burden",
          "title": "Emily’s Financial Burden",
          "active": true,
          "intro_text": null,
          "passed_text": null,
          "failure_text": null,
          "start_date": "2017-09-01",
          "end_date": "2018-09-01",
          "passing_grade": 0,
          "show_results_screen": false,
          "shuffle": false,
          "hide_grade": false,
          "show_intro": true
        },
        "relationships": {
          "sections": {
            "data": [{
              "id": "68",
              "type": "sections"
            }]
          }
        }
      },
      {
        "id": "68",
        "type": "response_set_sections",
        "attributes": {
          "title": "Emily’s Financial Burden",
          "active": true,
          "shuffle": false,
          "bank": false,
          "bank_count": null,
          "position": 1,
          "completed": false
        },
        "relationships": {
          "questions": {
            "data": [{
                "id": "269",
                "type": "response_set_questions"
              }
            ]
          }
        }
      },
      {
        "id": "269",
        "type": "response_set_questions",
        "attributes": {
          "text": "What change can Emily make to her budget to make the most impact?",
          "active": true,
          "shuffle": false,
          "position": 1,
          "responded": true
        },
        "relationships": {
          "answers": {
            "data": [{
                "id": "1064",
                "type": "answers"
              },
              {
                "id": "1065",
                "type": "answers"
              },
              {
                "id": "1066",
                "type": "answers"
              },
              {
                "id": "1067",
                "type": "answers"
              }
            ]
          }
        }
      },
      {
        "id": "1064",
        "type": "answers",
        "attributes": {
          "text": "Reduce her spending overall",
          "active": true,
          "position": 1
        }
      },
      {
        "id": "1065",
        "type": "answers",
        "attributes": {
          "text": "Get a more affordable cell phone or cable plan",
          "active": true,
          "position": 2
        }
      },
      {
        "id": "1066",
        "type": "answers",
        "attributes": {
          "text": "Reduce gas by carpooling",
          "active": true,
          "position": 3
        }
      },
        {
          "id": "1067",
          "type": "answers",
          "attributes": {
            "text": "Spend less on clothing, shoes, and hair",
            "active": true,
            "position": 3
          }
      }
    ]
  }
  
  })();
});

require.register("local-data/polls/what-is-a-business-plan.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "what-is-a-business-plan",
        "name": "What is a business plan?",
        "description": "How familiar are you with…",
        "title": "What is a business plan?",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "What is a business plan?",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "272",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "1. Could ideas on a napkin be a business plan?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "2. Could a one-page document be a business plan?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
            "id": "1064",
            "type": "answers"
          },
          {
            "id": "1065",
            "type": "answers"
          }
          ]
        }
      }
    },
    {
      "id": "272",
      "type": "response_set_questions",
      "attributes": {
        "text": "3. Could a 30-page document be a business plan?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
            "id": "1064",
            "type": "answers"
          },
          {
            "id": "1065",
            "type": "answers"
          }
          ]
        }
      }
    },
    {
      "id": "273",
      "type": "response_set_questions",
      "attributes": {
        "text": "Savings accounts?",
        "active": true,
        "shuffle": false,
        "position": 4,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
            "id": "1064",
            "type": "answers"
          },
          {
            "id": "1065",
            "type": "answers"
          },
          {
            "id": "1066",
            "type": "answers"
          }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "Yes",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "No",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-joans-retirement.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 74,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "74",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "74",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "74",
      "type": "evaluations",
      "attributes": {
        "slug": "pros-and-cons",
        "name": "Pros & Cons of Home Ownership",
        "description": "Pros & Cons",
        "title": "Pros & Cons of Home Ownership",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "74",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "74",
      "type": "response_set_sections",
      "attributes": {
        "title": "Pros & Cons",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "270",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "272",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "Which chart best describes how her money will grow over 40 years?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1034",
              "type": "answers"
            },
            {
              "id": "1035",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "270",
      "type": "response_set_questions",
      "attributes": {
        "text": "You need to make payments towards a home. Is this a pro or a con?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1034",
              "type": "answers"
            },
            {
              "id": "1035",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "You may need to pay taxes on the home. Is this a pro or a con?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1034",
              "type": "answers"
            },
            {
              "id": "1035",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "272",
      "type": "response_set_questions",
      "attributes": {
        "text": "You can remodel the home any way you like. Is this a pro or a con?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1034",
              "type": "answers"
            },
            {
              "id": "1035",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1034",
      "type": "answers",
      "attributes": {
        "text": "Chart A",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1035",
      "type": "answers",
      "attributes": {
        "text": "Chart B",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/financial-emergency2.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "68",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "financial-emergency2",
        "name": "Costs of Financial Emergencies",
        "title": "Costs of Financial Emergencies",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2020-12-01",
        "end_date": "2021-12-31",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "68",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Costs of Financial Emergencies",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 0,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "270",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "What does the average person pay for a health-related emergency?",
        "active": true,
        "shuffle": false,
        "position": 0,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },{
              "id": "1066",
              "type": "answers"
            },
            {
              "id": "1067",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "270",
      "type": "response_set_questions",
      "attributes": {
        "text": "What is the average cost of an emergency home repair?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1068",
              "type": "answers"
            },
            {
              "id": "1069",
              "type": "answers"
            },
            {
              "id": "1070",
              "type": "answers"
            },
            {
              "id": "1071",
              "type": "answers"
            }
          ]
        }
      }
    },      
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "After an unexpected job loss, how long does it take the average person to get a new job?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1072",
              "type": "answers"
            },
            {
              "id": "1073",
              "type": "answers"
            },
            {
              "id": "1074",
              "type": "answers"
            },
            {
              "id": "1075",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "$250",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "$500",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "1,200",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1067",
      "type": "answers",
      "attributes": {
        "text": "Trick question---health insurance covers all health-related emergencies",
        "active": true,
        "position": 4
      }
    },            
    {
      "id": "1068",
      "type": "answers",
      "attributes": {
        "text": "About $1,000",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1069",
      "type": "answers",
      "attributes": {
        "text": "About $750",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1070",
      "type": "answers",
      "attributes": {
        "text": "About $500",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1071",
      "type": "answers",
      "attributes": {
        "text": "About $120",
        "active": true,
        "position": 4
      }
    },            
    {
      "id": "1072",
      "type": "answers",
      "attributes": {
        "text": "1-2 months",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1073",
      "type": "answers",
      "attributes": {
        "text": "2-3 months",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1074",
      "type": "answers",
      "attributes": {
        "text": "3-6 months",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1075",
      "type": "answers",
      "attributes": {
        "text": "6-12 months",
        "active": true,
        "position": 4
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-busy-parent.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "68",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-busy-parent",
        "name": "Mobile Banking",
        "description": "Mobile Banking",
        "title": "Mobile Banking",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "68",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Mobile Banking",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "272",
              "type": "response_set_questions"
            },
            {
              "id": "273",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "There’s a correlation between mobile banking use and identity theft.",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "Whenever customers access sensitive personally identifiable information (PII) via mobile banking, they put themselves at risk of identity theft.",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "272",
      "type": "response_set_questions",
      "attributes": {
        "text": "Consumers are more susceptible to making spur of the moment, or impulse purchases when using mobile banking.",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "273",
      "type": "response_set_questions",
      "attributes": {
        "text": "From June to August 2019, an average of $160,000 fraudulent transactions per month were reported by businesses, including retail and eCommerce sites.",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "True",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "False",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/wesb-q2.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "protecting-money",
        "name": "Ali's Decision: Part 1",
        "description": "Ali's Decision: Part 1",
        "title": "Ali's Decision: Part 1",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Ali's Decision: Part 1",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "What other options would work for Ali so that his money is protected?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            },
            {
              "id": "1067",
              "type": "answers"
            },
            {
              "id": "1068",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "A checking account.",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "A traditional savings account.",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "A certificate of deposit (CD)",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1067",
      "type": "answers",
      "attributes": {
        "text": "A money market account (MMA)",
        "active": true,
        "position": 4
      }
    },
    {
      "id": "1068",
      "type": "answers",
      "attributes": {
        "text": "A special account for a minor",
        "active": true,
        "position": 5
      }
    }
  ]
}
  })();
});

require.register("local-data/polls/wesb-q7.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "protecting-money",
        "name": "Ali's Decision: Part 1",
        "description": "Ali's Decision: Part 1",
        "title": "Ali's Decision: Part 1",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Ali's Decision: Part 1",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "What other options would work for Ali so that his money is protected?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            },
            {
              "id": "1067",
              "type": "answers"
            },
            {
              "id": "1068",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "A checking account.",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "A traditional savings account.",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "A certificate of deposit (CD)",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1067",
      "type": "answers",
      "attributes": {
        "text": "A money market account (MMA)",
        "active": true,
        "position": 4
      }
    },
    {
      "id": "1068",
      "type": "answers",
      "attributes": {
        "text": "A special account for a minor",
        "active": true,
        "position": 5
      }
    }
  ]
}
  })();
});

require.register("local-data/polls/buying-a-car-s1-p10.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "68",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Buying a Car",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "270",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "272",
              "type": "response_set_questions"
            },
            {
              "id": "273",
              "type": "response_set_questions"
            },
            {
              "id": "274",
              "type": "response_set_questions"
            },
            {
              "id": "275",
              "type": "response_set_questions"
            },
            {
              "id": "276",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "What do you think the average cost of owning a vehicle comes out to each month?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            },
            {
              "id": "1067",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "270",
      "type": "response_set_questions",
      "attributes": {
        "text": "Do you drive more than 10,000 miles per year?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1068",
              "type": "answers"
            },
            {
              "id": "1069",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "Do you tend to put a lot of wear on your vehicle (scratches, dents, upholstery wear)?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1068",
              "type": "answers"
            },
            {
              "id": "1069",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "272",
      "type": "response_set_questions",
      "attributes": {
        "text": "Do you plan to move out of the area in the next 2-3 years?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1068",
              "type": "answers"
            },
            {
              "id": "1069",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "273",
      "type": "response_set_questions",
      "attributes": {
        "text": "Do you want to be able to sell the vehicle later?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1068",
              "type": "answers"
            },
            {
              "id": "1069",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "274",
      "type": "response_set_questions",
      "attributes": {
        "text": "Who do you think got the better deal, Thomas or Sari?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1070",
              "type": "answers"
            },
            {
              "id": "1071",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "275",
      "type": "response_set_questions",
      "attributes": {
        "text": "Can Lane afford her dream car based on the 20/4/10 Rule?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1068",
              "type": "answers"
            },
            {
              "id": "1069",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "276",
      "type": "response_set_questions",
      "attributes": {
        "text": "Do you feel you learned more about buying a car after taking this course?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1068",
              "type": "answers"
            },
            {
              "id": "1069",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "$500",
        "active": true,
        "position": 0
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "$225",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "$100",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1067",
      "type": "answers",
      "attributes": {
        "text": "$825",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1068",
      "type": "answers",
      "attributes": {
        "text": "Yes",
        "active": true,
        "position": 0
      }
    },
    {
      "id": "1069",
      "type": "answers",
      "attributes": {
        "text": "No",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1070",
      "type": "answers",
      "attributes": {
        "text": "Thomas",
        "active": true,
        "position": 0
      }
    },
    {
      "id": "1071",
      "type": "answers",
      "attributes": {
        "text": "Sari",
        "active": true,
        "position": 1
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/pros-and-cons.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "27235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 74,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "74",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "74",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "74",
      "type": "evaluations",
      "attributes": {
        "slug": "pros-and-cons",
        "name": "Pros & Cons of Home Ownership",
        "description": "Pros & Cons",
        "title": "Pros & Cons of Home Ownership",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "74",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "74",
      "type": "response_set_sections",
      "attributes": {
        "title": "Pros & Cons",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "270",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "272",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "A home has long term value. Is this a pro or a con?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1034",
              "type": "answers"
            },
            {
              "id": "1035",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "270",
      "type": "response_set_questions",
      "attributes": {
        "text": "You need to make payments towards a home. Is this a pro or a con?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1034",
              "type": "answers"
            },
            {
              "id": "1035",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "You may need to pay taxes on the home. Is this a pro or a con?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1034",
              "type": "answers"
            },
            {
              "id": "1035",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "272",
      "type": "response_set_questions",
      "attributes": {
        "text": "You can remodel the home any way you like. Is this a pro or a con?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1034",
              "type": "answers"
            },
            {
              "id": "1035",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1034",
      "type": "answers",
      "attributes": {
        "text": "Pro",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1035",
      "type": "answers",
      "attributes": {
        "text": "Con",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/kaylees-debt-repayment-strategy.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "kaylees-debt-repayment-strategy_poll",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": "EX_POLL_QUES_1",
          "value": "EX_POLL_ANS_1",
          "response_type": "single_selection"
        },
        {
          "question_id": "EX_POLL_QUES_2",
          "value": "EX_POLL_ANS_2",
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "68",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "kaylees-debt-repayment-strategy",
        "name": "Kaylee’s Debt Repayment Strategy",
        "description": "",
        "title": "Kaylee’s Debt Repayment Strategy",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "68",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Kaylee’s Debt Repayment Strategy",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "EX_POLL_QUES_1",
              "type": "response_set_questions"
            },
            {
              "id": "EX_POLL_QUES_2",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "EX_POLL_QUES_1",
      "type": "response_set_questions",
      "attributes": {
        "text": "Using the Avalanche Method, which debt should Kaylee pay off first?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "EX_POLL_ANS_1",
              "type": "answers"
            },
            {
              "id": "EX_POLL_ANS_2",
              "type": "answers"
            },
            {
              "id": "EX_POLL_ANS_3",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "EX_POLL_QUES_2",
      "type": "response_set_questions",
      "attributes": {
        "text": "Using the Snowball Method, which debt should Kaylee pay off first?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "EX_POLL_ANS_1",
              "type": "answers"
            },
            {
              "id": "EX_POLL_ANS_2",
              "type": "answers"
            },
            {
              "id": "EX_POLL_ANS_3",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "EX_POLL_ANS_1",
      "type": "answers",
      "attributes": {
        "text": "Major credit card",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "EX_POLL_ANS_2",
      "type": "answers",
      "attributes": {
        "text": "Store credit card",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "EX_POLL_ANS_3",
      "type": "answers",
      "attributes": {
        "text": "Personal loan",
        "active": true,
        "position": 3
      }
    }
  ]
}
  })();
});

require.register("local-data/polls/wesb-q4.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "protecting-money",
        "name": "Ali's Decision: Part 1",
        "description": "Ali's Decision: Part 1",
        "title": "Ali's Decision: Part 1",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Ali's Decision: Part 1",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "What other options would work for Ali so that his money is protected?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            },
            {
              "id": "1066",
              "type": "answers"
            },
            {
              "id": "1067",
              "type": "answers"
            },
            {
              "id": "1068",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "A checking account.",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "A traditional savings account.",
        "active": true,
        "position": 2
      }
    },
    {
      "id": "1066",
      "type": "answers",
      "attributes": {
        "text": "A certificate of deposit (CD)",
        "active": true,
        "position": 3
      }
    },
    {
      "id": "1067",
      "type": "answers",
      "attributes": {
        "text": "A money market account (MMA)",
        "active": true,
        "position": 4
      }
    },
    {
      "id": "1068",
      "type": "answers",
      "attributes": {
        "text": "A special account for a minor",
        "active": true,
        "position": 5
      }
    }
  ]
}
  })();
});

require.register("local-data/polls/financial-emergency3.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [
        {
          "question_id": 269,
          "value": 1065,
          "response_type": "single_selection"
        }
      ],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [
          {
            "id": "68",
            "type": "response_set_sections"
          }
        ]
      }
    }
  },
  "included": [
    {
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "financial-emergency2",
        "name": "Costs of Financial Emergencies",
        "title": "Costs of Financial Emergencies",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2020-12-01",
        "end_date": "2021-12-31",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [
            {
              "id": "68",
              "type": "sections"
            }
          ]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Costs of Financial Emergencies",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 0,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [
            {
              "id": "269",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "Do you feel like you have gained knowledge on how to prepare for a financial emergency after taking this course?",
        "active": true,
        "shuffle": false,
        "position": 0,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [
            {
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "Yes",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "No",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/scenarios-budgeting-for-mortgage.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "scenarios-budgeting-for-mortgage",
        "name": "Budgeting for Mortgage",
        "description": "Budgeting for Mortgage",
        "title": "Budgeting for Mortgage",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "Budgeting for Mortgage",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "272",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "I keep a record of what I earn each month.",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "I keep a record of what I spend each month.",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "272",
      "type": "response_set_questions",
      "attributes": {
        "text": "I keep a record of what I save each month.",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "Yes",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "No",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

require.register("local-data/polls/who-got-the-best-financial-deal.json", function(exports, require, module) {
  module.exports = (function() {
return {
  "data": {
    "id": "21235e41-02cc-4d43-8e02-3e29406a4923",
    "type": "response_sets",
    "attributes": {
      "time_taken": null,
      "fields": {},
      "answers": [{
        "question_id": 269,
        "value": 1065,
        "response_type": "single_selection"
      }],
      "current_section_id": 68,
      "grade": null,
      "status": "started",
      "web_hooks": {},
      "evaluation_has_started": false
    },
    "relationships": {
      "evaluation": {
        "data": {
          "id": "68",
          "type": "evaluations"
        }
      },
      "sections": {
        "data": [{
          "id": "68",
          "type": "response_set_sections"
        }]
      }
    }
  },
  "included": [{
      "id": "68",
      "type": "evaluations",
      "attributes": {
        "slug": "what-is-a-business-plan",
        "name": "What is a business plan?",
        "description": "How familiar are you with…",
        "title": "What is a business plan?",
        "active": true,
        "intro_text": null,
        "passed_text": null,
        "failure_text": null,
        "start_date": "2017-09-01",
        "end_date": "2018-09-01",
        "passing_grade": 0,
        "show_results_screen": false,
        "shuffle": false,
        "hide_grade": false,
        "show_intro": true
      },
      "relationships": {
        "sections": {
          "data": [{
            "id": "68",
            "type": "sections"
          }]
        }
      }
    },
    {
      "id": "68",
      "type": "response_set_sections",
      "attributes": {
        "title": "What is a business plan?",
        "active": true,
        "shuffle": false,
        "bank": false,
        "bank_count": null,
        "position": 1,
        "completed": false
      },
      "relationships": {
        "questions": {
          "data": [{
              "id": "269",
              "type": "response_set_questions"
            },
            {
              "id": "271",
              "type": "response_set_questions"
            },
            {
              "id": "272",
              "type": "response_set_questions"
            }
          ]
        }
      }
    },
    {
      "id": "269",
      "type": "response_set_questions",
      "attributes": {
        "text": "Who got the best financial deal?",
        "active": true,
        "shuffle": false,
        "position": 1,
        "responded": true
      },
      "relationships": {
        "answers": {
          "data": [{
              "id": "1064",
              "type": "answers"
            },
            {
              "id": "1065",
              "type": "answers"
            }
          ]
        }
      }
    },
    {
      "id": "271",
      "type": "response_set_questions",
      "attributes": {
        "text": "2. Could a one-page document be a business plan?",
        "active": true,
        "shuffle": false,
        "position": 2,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
            "id": "1064",
            "type": "answers"
          },
          {
            "id": "1065",
            "type": "answers"
          }
          ]
        }
      }
    },
    {
      "id": "272",
      "type": "response_set_questions",
      "attributes": {
        "text": "3. Could a 30-page document be a business plan?",
        "active": true,
        "shuffle": false,
        "position": 3,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
            "id": "1064",
            "type": "answers"
          },
          {
            "id": "1065",
            "type": "answers"
          }
          ]
        }
      }
    },
    {
      "id": "273",
      "type": "response_set_questions",
      "attributes": {
        "text": "Savings accounts?",
        "active": true,
        "shuffle": false,
        "position": 4,
        "responded": false
      },
      "relationships": {
        "answers": {
          "data": [{
            "id": "1064",
            "type": "answers"
          },
          {
            "id": "1065",
            "type": "answers"
          },
          {
            "id": "1066",
            "type": "answers"
          }
          ]
        }
      }
    },
    {
      "id": "1064",
      "type": "answers",
      "attributes": {
        "text": "Min Ho",
        "active": true,
        "position": 1
      }
    },
    {
      "id": "1065",
      "type": "answers",
      "attributes": {
        "text": "Javier",
        "active": true,
        "position": 2
      }
    }
  ]
}

  })();
});

